import React from "react";

export const Store = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      //
      //xmlns:xlink="http://www.w3.org/1999/xlink"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24" />
        <path
          d="M14,9 L14,8 C14,6.8954305 13.1045695,6 12,6 C10.8954305,6 10,6.8954305 10,8 L10,9 L8,9 L8,8 C8,5.790861 9.790861,4 12,4 C14.209139,4 16,5.790861 16,8 L16,9 L14,9 Z M14,9 L14,8 C14,6.8954305 13.1045695,6 12,6 C10.8954305,6 10,6.8954305 10,8 L10,9 L8,9 L8,8 C8,5.790861 9.790861,4 12,4 C14.209139,4 16,5.790861 16,8 L16,9 L14,9 Z"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.3"
        />
        <path
          d="M6.84712709,9 L17.1528729,9 C17.6417121,9 18.0589022,9.35341304 18.1392668,9.83560101 L19.611867,18.671202 C19.7934571,19.7607427 19.0574178,20.7911977 17.9678771,20.9727878 C17.8592143,20.9908983 17.7492409,21 17.6390792,21 L6.36092084,21 C5.25635134,21 4.36092084,20.1045695 4.36092084,19 C4.36092084,18.8898383 4.37002252,18.7798649 4.388133,18.671202 L5.86073316,9.83560101 C5.94109783,9.35341304 6.35828794,9 6.84712709,9 Z"
          fill="#000000"
        />
      </g>
    </svg>
  );
};

export const Driver = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      //
      //xmlns:xlink="http://www.w3.org/1999/xlink"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon points="0 0 24 0 24 24 0 24" />
        <path
          d="M18,14 C16.3431458,14 15,12.6568542 15,11 C15,9.34314575 16.3431458,8 18,8 C19.6568542,8 21,9.34314575 21,11 C21,12.6568542 19.6568542,14 18,14 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.3"
        />
        <path
          d="M17.6011961,15.0006174 C21.0077043,15.0378534 23.7891749,16.7601418 23.9984937,20.4 C24.0069246,20.5466056 23.9984937,21 23.4559499,21 L19.6,21 C19.6,18.7490654 18.8562935,16.6718327 17.6011961,15.0006174 Z M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z"
          fill="#000000"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
};

export const Cms = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      //
      //xmlns:xlink="http://www.w3.org/1999/xlink"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon points="0 0 24 0 24 24 0 24" />
        <path
          d="M12.9336061,16.072447 L19.36,10.9564761 L19.5181585,10.8312381 C20.1676248,10.3169571 20.2772143,9.3735535 19.7629333,8.72408713 C19.6917232,8.63415859 19.6104327,8.55269514 19.5206557,8.48129411 L12.9336854,3.24257445 C12.3871201,2.80788259 11.6128799,2.80788259 11.0663146,3.24257445 L4.47482784,8.48488609 C3.82645598,9.00054628 3.71887192,9.94418071 4.23453211,10.5925526 C4.30500305,10.6811601 4.38527899,10.7615046 4.47382636,10.8320511 L4.63,10.9564761 L11.0659024,16.0730648 C11.6126744,16.5077525 12.3871218,16.5074963 12.9336061,16.072447 Z"
          fill="#000000"
          fillRule="nonzero"
        />
        <path
          d="M11.0563554,18.6706981 L5.33593024,14.122919 C4.94553994,13.8125559 4.37746707,13.8774308 4.06710397,14.2678211 C4.06471678,14.2708238 4.06234874,14.2738418 4.06,14.2768747 L4.06,14.2768747 C3.75257288,14.6738539 3.82516916,15.244888 4.22214834,15.5523151 C4.22358765,15.5534297 4.2250303,15.55454 4.22647627,15.555646 L11.0872776,20.8031356 C11.6250734,21.2144692 12.371757,21.2145375 12.909628,20.8033023 L19.7677785,15.559828 C20.1693192,15.2528257 20.2459576,14.6784381 19.9389553,14.2768974 C19.9376429,14.2751809 19.9363245,14.2734691 19.935,14.2717619 L19.935,14.2717619 C19.6266937,13.8743807 19.0546209,13.8021712 18.6572397,14.1104775 C18.654352,14.112718 18.6514778,14.1149757 18.6486172,14.1172508 L12.9235044,18.6705218 C12.377022,19.1051477 11.6029199,19.1052208 11.0563554,18.6706981 Z"
          fill="#000000"
          opacity="0.3"
        />
      </g>
    </svg>
  );
};

// export const Dashboard = () => {
//   return (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       //
//       //xmlns:xlink="http://www.w3.org/1999/xlink"
//       width="24px"
//       height="24px"
//       viewBox="0 0 24 24"
//       version="1.1"
//     >
//       <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
//         <polygon points="0 0 24 0 24 24 0 24" />
//         <path
//           d="M12.9336061,16.072447 L19.36,10.9564761 L19.5181585,10.8312381 C20.1676248,10.3169571 20.2772143,9.3735535 19.7629333,8.72408713 C19.6917232,8.63415859 19.6104327,8.55269514 19.5206557,8.48129411 L12.9336854,3.24257445 C12.3871201,2.80788259 11.6128799,2.80788259 11.0663146,3.24257445 L4.47482784,8.48488609 C3.82645598,9.00054628 3.71887192,9.94418071 4.23453211,10.5925526 C4.30500305,10.6811601 4.38527899,10.7615046 4.47382636,10.8320511 L4.63,10.9564761 L11.0659024,16.0730648 C11.6126744,16.5077525 12.3871218,16.5074963 12.9336061,16.072447 Z"
//           fill="#000000"
//           fillRule="nonzero"
//         />
//         <path
//           d="M11.0563554,18.6706981 L5.33593024,14.122919 C4.94553994,13.8125559 4.37746707,13.8774308 4.06710397,14.2678211 C4.06471678,14.2708238 4.06234874,14.2738418 4.06,14.2768747 L4.06,14.2768747 C3.75257288,14.6738539 3.82516916,15.244888 4.22214834,15.5523151 C4.22358765,15.5534297 4.2250303,15.55454 4.22647627,15.555646 L11.0872776,20.8031356 C11.6250734,21.2144692 12.371757,21.2145375 12.909628,20.8033023 L19.7677785,15.559828 C20.1693192,15.2528257 20.2459576,14.6784381 19.9389553,14.2768974 C19.9376429,14.2751809 19.9363245,14.2734691 19.935,14.2717619 L19.935,14.2717619 C19.6266937,13.8743807 19.0546209,13.8021712 18.6572397,14.1104775 C18.654352,14.112718 18.6514778,14.1149757 18.6486172,14.1172508 L12.9235044,18.6705218 C12.377022,19.1051477 11.6029199,19.1052208 11.0563554,18.6706981 Z"
//           fill="#000000"
//           opacity="0.3"
//         />
//       </g>
//     </svg>
//   );
// };

export const Dashboard = () => {
  return (
    <span className="svg-icon svg-icon-primary svg-icon-2x">
      <svg
        // xmlns="http://www.w3.org/2000/svg"
        // xmlnsXlink="http://www.w3.org/1999/xlink"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <rect x={0} y={0} width={24} height={24} />
          <rect fill="#000000" x={4} y={4} width={7} height={7} rx="1.5" />
          <path
            d="M5.5,13 L9.5,13 C10.3284271,13 11,13.6715729 11,14.5 L11,18.5 C11,19.3284271 10.3284271,20 9.5,20 L5.5,20 C4.67157288,20 4,19.3284271 4,18.5 L4,14.5 C4,13.6715729 4.67157288,13 5.5,13 Z M14.5,4 L18.5,4 C19.3284271,4 20,4.67157288 20,5.5 L20,9.5 C20,10.3284271 19.3284271,11 18.5,11 L14.5,11 C13.6715729,11 13,10.3284271 13,9.5 L13,5.5 C13,4.67157288 13.6715729,4 14.5,4 Z M14.5,13 L18.5,13 C19.3284271,13 20,13.6715729 20,14.5 L20,18.5 C20,19.3284271 19.3284271,20 18.5,20 L14.5,20 C13.6715729,20 13,19.3284271 13,18.5 L13,14.5 C13,13.6715729 13.6715729,13 14.5,13 Z"
            fill="#000000"
            opacity="0.3"
          />
        </g>
      </svg>
      {/*end::Svg Icon*/}
    </span>
  );
};

export const Settings = () => {
  return (
    <span className="svg-icon svg-icon-primary svg-icon-2x">
      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <rect x={0} y={0} width={24} height={24} />
          <path
            d="M18.6225,9.75 L18.75,9.75 C19.9926407,9.75 21,10.7573593 21,12 C21,13.2426407 19.9926407,14.25 18.75,14.25 L18.6854912,14.249994 C18.4911876,14.250769 18.3158978,14.366855 18.2393549,14.5454486 C18.1556809,14.7351461 18.1942911,14.948087 18.3278301,15.0846699 L18.372535,15.129375 C18.7950334,15.5514036 19.03243,16.1240792 19.03243,16.72125 C19.03243,17.3184208 18.7950334,17.8910964 18.373125,18.312535 C17.9510964,18.7350334 17.3784208,18.97243 16.78125,18.97243 C16.1840792,18.97243 15.6114036,18.7350334 15.1896699,18.3128301 L15.1505513,18.2736469 C15.008087,18.1342911 14.7951461,18.0956809 14.6054486,18.1793549 C14.426855,18.2558978 14.310769,18.4311876 14.31,18.6225 L14.31,18.75 C14.31,19.9926407 13.3026407,21 12.06,21 C10.8173593,21 9.81,19.9926407 9.81,18.75 C9.80552409,18.4999185 9.67898539,18.3229986 9.44717599,18.2361469 C9.26485393,18.1556809 9.05191298,18.1942911 8.91533009,18.3278301 L8.870625,18.372535 C8.44859642,18.7950334 7.87592081,19.03243 7.27875,19.03243 C6.68157919,19.03243 6.10890358,18.7950334 5.68746499,18.373125 C5.26496665,17.9510964 5.02757002,17.3784208 5.02757002,16.78125 C5.02757002,16.1840792 5.26496665,15.6114036 5.68716991,15.1896699 L5.72635306,15.1505513 C5.86570889,15.008087 5.90431906,14.7951461 5.82064513,14.6054486 C5.74410223,14.426855 5.56881236,14.310769 5.3775,14.31 L5.25,14.31 C4.00735931,14.31 3,13.3026407 3,12.06 C3,10.8173593 4.00735931,9.81 5.25,9.81 C5.50008154,9.80552409 5.67700139,9.67898539 5.76385306,9.44717599 C5.84431906,9.26485393 5.80570889,9.05191298 5.67216991,8.91533009 L5.62746499,8.870625 C5.20496665,8.44859642 4.96757002,7.87592081 4.96757002,7.27875 C4.96757002,6.68157919 5.20496665,6.10890358 5.626875,5.68746499 C6.04890358,5.26496665 6.62157919,5.02757002 7.21875,5.02757002 C7.81592081,5.02757002 8.38859642,5.26496665 8.81033009,5.68716991 L8.84944872,5.72635306 C8.99191298,5.86570889 9.20485393,5.90431906 9.38717599,5.82385306 L9.49484664,5.80114977 C9.65041313,5.71688974 9.7492905,5.55401473 9.75,5.3775 L9.75,5.25 C9.75,4.00735931 10.7573593,3 12,3 C13.2426407,3 14.25,4.00735931 14.25,5.25 L14.249994,5.31450877 C14.250769,5.50881236 14.366855,5.68410223 14.552824,5.76385306 C14.7351461,5.84431906 14.948087,5.80570889 15.0846699,5.67216991 L15.129375,5.62746499 C15.5514036,5.20496665 16.1240792,4.96757002 16.72125,4.96757002 C17.3184208,4.96757002 17.8910964,5.20496665 18.312535,5.626875 C18.7350334,6.04890358 18.97243,6.62157919 18.97243,7.21875 C18.97243,7.81592081 18.7350334,8.38859642 18.3128301,8.81033009 L18.2736469,8.84944872 C18.1342911,8.99191298 18.0956809,9.20485393 18.1761469,9.38717599 L18.1988502,9.49484664 C18.2831103,9.65041313 18.4459853,9.7492905 18.6225,9.75 Z"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.5"
          />
          <path
            d="M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 Z"
            fill="#000000"
          />
        </g>
      </svg>
      {/*end::Svg Icon*/}
    </span>
  );
};

export const View = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24" />
        <path
          d="M12.8434797,16 L11.1565203,16 L10.9852159,16.6393167 C10.3352654,19.064965 7.84199997,20.5044524 5.41635172,19.8545019 C2.99070348,19.2045514 1.55121603,16.711286 2.20116652,14.2856378 L3.92086709,7.86762789 C4.57081758,5.44197964 7.06408298,4.00249219 9.48973122,4.65244268 C10.5421727,4.93444352 11.4089671,5.56345262 12,6.38338695 C12.5910329,5.56345262 13.4578273,4.93444352 14.5102688,4.65244268 C16.935917,4.00249219 19.4291824,5.44197964 20.0791329,7.86762789 L21.7988335,14.2856378 C22.448784,16.711286 21.0092965,19.2045514 18.5836483,19.8545019 C16.158,20.5044524 13.6647346,19.064965 13.0147841,16.6393167 L12.8434797,16 Z M17.4563502,18.1051865 C18.9630797,18.1051865 20.1845253,16.8377967 20.1845253,15.2743923 C20.1845253,13.7109878 18.9630797,12.4435981 17.4563502,12.4435981 C15.9496207,12.4435981 14.7281751,13.7109878 14.7281751,15.2743923 C14.7281751,16.8377967 15.9496207,18.1051865 17.4563502,18.1051865 Z M6.54364977,18.1051865 C8.05037928,18.1051865 9.27182488,16.8377967 9.27182488,15.2743923 C9.27182488,13.7109878 8.05037928,12.4435981 6.54364977,12.4435981 C5.03692026,12.4435981 3.81547465,13.7109878 3.81547465,15.2743923 C3.81547465,16.8377967 5.03692026,18.1051865 6.54364977,18.1051865 Z"
          fill="#000000"
        />
      </g>
    </svg>
  );
};

export const Edit = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24" />
        <path
          d="M3,16 L5,16 C5.55228475,16 6,15.5522847 6,15 C6,14.4477153 5.55228475,14 5,14 L3,14 L3,12 L5,12 C5.55228475,12 6,11.5522847 6,11 C6,10.4477153 5.55228475,10 5,10 L3,10 L3,8 L5,8 C5.55228475,8 6,7.55228475 6,7 C6,6.44771525 5.55228475,6 5,6 L3,6 L3,4 C3,3.44771525 3.44771525,3 4,3 L10,3 C10.5522847,3 11,3.44771525 11,4 L11,19 C11,19.5522847 10.5522847,20 10,20 L4,20 C3.44771525,20 3,19.5522847 3,19 L3,16 Z"
          fill="#000000"
          opacity="0.3"
        />
        <path
          d="M16,3 L19,3 C20.1045695,3 21,3.8954305 21,5 L21,15.2485298 C21,15.7329761 20.8241635,16.200956 20.5051534,16.565539 L17.8762883,19.5699562 C17.6944473,19.7777745 17.378566,19.7988332 17.1707477,19.6169922 C17.1540423,19.602375 17.1383289,19.5866616 17.1237117,19.5699562 L14.4948466,16.565539 C14.1758365,16.200956 14,15.7329761 14,15.2485298 L14,5 C14,3.8954305 14.8954305,3 16,3 Z"
          fill="#000000"
        />
      </g>
    </svg>
  );
};

export const Delete = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24" />
        <path
          d="M6,8 L6,20.5 C6,21.3284271 6.67157288,22 7.5,22 L16.5,22 C17.3284271,22 18,21.3284271 18,20.5 L18,8 L6,8 Z"
          fill="#000000"
          fillRule="nonzero"
        />
        <path
          d="M14,4.5 L14,4 C14,3.44771525 13.5522847,3 13,3 L11,3 C10.4477153,3 10,3.44771525 10,4 L10,4.5 L5.5,4.5 C5.22385763,4.5 5,4.72385763 5,5 L5,5.5 C5,5.77614237 5.22385763,6 5.5,6 L18.5,6 C18.7761424,6 19,5.77614237 19,5.5 L19,5 C19,4.72385763 18.7761424,4.5 18.5,4.5 L14,4.5 Z"
          fill="#000000"
          opacity="0.3"
        />
      </g>
    </svg>
  );
};

export const SystemManagement = () => {
  return (
    <span className="svg-icon svg-icon-primary svg-icon-2x">
      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <rect x={0} y={0} width={24} height={24} />
          <path
            d="M5,2 L19,2 C20.1045695,2 21,2.8954305 21,4 L21,6 C21,7.1045695 20.1045695,8 19,8 L5,8 C3.8954305,8 3,7.1045695 3,6 L3,4 C3,2.8954305 3.8954305,2 5,2 Z M11,4 C10.4477153,4 10,4.44771525 10,5 C10,5.55228475 10.4477153,6 11,6 L16,6 C16.5522847,6 17,5.55228475 17,5 C17,4.44771525 16.5522847,4 16,4 L11,4 Z M7,6 C7.55228475,6 8,5.55228475 8,5 C8,4.44771525 7.55228475,4 7,4 C6.44771525,4 6,4.44771525 6,5 C6,5.55228475 6.44771525,6 7,6 Z"
            fill="#000000"
            opacity="0.3"
          />
          <path
            d="M5,9 L19,9 C20.1045695,9 21,9.8954305 21,11 L21,13 C21,14.1045695 20.1045695,15 19,15 L5,15 C3.8954305,15 3,14.1045695 3,13 L3,11 C3,9.8954305 3.8954305,9 5,9 Z M11,11 C10.4477153,11 10,11.4477153 10,12 C10,12.5522847 10.4477153,13 11,13 L16,13 C16.5522847,13 17,12.5522847 17,12 C17,11.4477153 16.5522847,11 16,11 L11,11 Z M7,13 C7.55228475,13 8,12.5522847 8,12 C8,11.4477153 7.55228475,11 7,11 C6.44771525,11 6,11.4477153 6,12 C6,12.5522847 6.44771525,13 7,13 Z"
            fill="#000000"
          />
          <path
            d="M5,16 L19,16 C20.1045695,16 21,16.8954305 21,18 L21,20 C21,21.1045695 20.1045695,22 19,22 L5,22 C3.8954305,22 3,21.1045695 3,20 L3,18 C3,16.8954305 3.8954305,16 5,16 Z M11,18 C10.4477153,18 10,18.4477153 10,19 C10,19.5522847 10.4477153,20 11,20 L16,20 C16.5522847,20 17,19.5522847 17,19 C17,18.4477153 16.5522847,18 16,18 L11,18 Z M7,20 C7.55228475,20 8,19.5522847 8,19 C8,18.4477153 7.55228475,18 7,18 C6.44771525,18 6,18.4477153 6,19 C6,19.5522847 6.44771525,20 7,20 Z"
            fill="#000000"
          />
        </g>
      </svg>
      {/*end::Svg Icon*/}
    </span>
  );
};
export const Masters = () => {
  return (
    <span className="svg-icon svg-icon-primary svg-icon-2x">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512">
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <rect x={0} y={0} width={24} height={24} />
          <path
            d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm52.7 93c8.8-15.2 28.3-20.5 43.5-11.7 15.3 8.8 20.5 28.3 11.7 43.6-8.8 15.2-28.3 20.5-43.5 11.7-15.3-8.9-20.5-28.4-11.7-43.6zM87.4 287.9c-17.6 0-31.9-14.3-31.9-31.9 0-17.6 14.3-31.9 31.9-31.9 17.6 0 31.9 14.3 31.9 31.9 0 17.6-14.3 31.9-31.9 31.9zm28.1 3.1c22.3-17.9 22.4-51.9 0-69.9 8.6-32.8 29.1-60.7 56.5-79.1l23.7 39.6c-51.5 36.3-51.5 112.5 0 148.8L172 370c-27.4-18.3-47.8-46.3-56.5-79zm228.7 131.7c-15.3 8.8-34.7 3.6-43.5-11.7-8.8-15.3-3.6-34.8 11.7-43.6 15.2-8.8 34.7-3.6 43.5 11.7 8.8 15.3 3.6 34.8-11.7 43.6zm.3-69.5c-26.7-10.3-56.1 6.6-60.5 35-5.2 1.4-48.9 14.3-96.7-9.4l22.5-40.3c57 26.5 123.4-11.7 128.9-74.4l46.1 .7c-2.3 34.5-17.3 65.5-40.3 88.4zm-5.9-105.3c-5.4-62-71.3-101.2-128.9-74.4l-22.5-40.3c47.9-23.7 91.5-10.8 96.7-9.4 4.4 28.3 33.8 45.3 60.5 35 23.1 22.9 38 53.9 40.2 88.5l-46 .6z"
            fill="#000000"
          />
        </g>
      </svg>
      {/*end::Svg Icon*/}
    </span>
  );
};
export const Model = () => {
  return (
    <span className="svg-icon svg-icon-primary svg-icon-2x">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <path
            d="M544 192h-16L419.2 56A64 64 0 0 0 369.2 32H155.3c-26.2 0-49.7 15.9-59.4 40.2L48 194.3C20.4 201.4 0 226.2 0 256v112c0 8.8 7.2 16 16 16h48c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-80c0-53-43-96-96-96zM160 432c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm72-240H116.9l38.4-96H232v96zm48 0V96h89.2l76.8 96H280zm200 240c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
            fill="#000000"
          />
        </g>
      </svg>
    </span>
  );
};
export const Year = () => {
  return (
    <span className="svg-icon svg-icon-primary svg-icon-2x">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
        <g stroke="none" strokeWidth={1} fillRule="evenodd">
          <path
            d="M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
            fill="#000000"
          />
        </g>
      </svg>
    </span>
  );
};
export const Version = () => {
  return (
    <span className="svg-icon svg-icon-primary svg-icon-2x">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
        <g stroke="none" strokeWidth={1} fillRule="evenodd">
          <path
            d="M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1 .1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9 .4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9 .1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1 .1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"
            fill="#000000"
          />
        </g>
      </svg>
    </span>
  );
};

export const Arrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      //
      //xmlns:xlink="http://www.w3.org/1999/xlink"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon points="0 0 24 0 24 24 0 24" />
        <path
          d="M5.29288961,6.70710318 C4.90236532,6.31657888 4.90236532,5.68341391 5.29288961,5.29288961 C5.68341391,4.90236532 6.31657888,4.90236532 6.70710318,5.29288961 L12.7071032,11.2928896 C13.0856821,11.6714686 13.0989277,12.281055 12.7371505,12.675721 L7.23715054,18.675721 C6.86395813,19.08284 6.23139076,19.1103429 5.82427177,18.7371505 C5.41715278,18.3639581 5.38964985,17.7313908 5.76284226,17.3242718 L10.6158586,12.0300721 L5.29288961,6.70710318 Z"
          fill="#000000"
          fillRule="nonzero"
          transform="translate(8.999997, 11.999999) scale(-1, 1) translate(-8.999997, -11.999999) "
        />
        <path
          d="M10.7071009,15.7071068 C10.3165766,16.0976311 9.68341162,16.0976311 9.29288733,15.7071068 C8.90236304,15.3165825 8.90236304,14.6834175 9.29288733,14.2928932 L15.2928873,8.29289322 C15.6714663,7.91431428 16.2810527,7.90106866 16.6757187,8.26284586 L22.6757187,13.7628459 C23.0828377,14.1360383 23.1103407,14.7686056 22.7371482,15.1757246 C22.3639558,15.5828436 21.7313885,15.6103465 21.3242695,15.2371541 L16.0300699,10.3841378 L10.7071009,15.7071068 Z"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.3"
          transform="translate(15.999997, 11.999999) scale(-1, 1) rotate(-270.000000) translate(-15.999997, -11.999999) "
        />
      </g>
    </svg>
  );
};

export const GoogleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M19.9895 10.1871C19.9895 9.36767 19.9214 8.76973 19.7742 8.14966H10.1992V11.848H15.8195C15.7062 12.7671 15.0943 14.1512 13.7346 15.0813L13.7155 15.2051L16.7429 17.4969L16.9527 17.5174C18.879 15.7789 19.9895 13.221 19.9895 10.1871Z"
        fill="#4285F4"
      />
      <path
        d="M10.1993 19.9313C12.9527 19.9313 15.2643 19.0454 16.9527 17.5174L13.7346 15.0813C12.8734 15.6682 11.7176 16.0779 10.1993 16.0779C7.50243 16.0779 5.21352 14.3395 4.39759 11.9366L4.27799 11.9466L1.13003 14.3273L1.08887 14.4391C2.76588 17.6945 6.21061 19.9313 10.1993 19.9313Z"
        fill="#34A853"
      />
      <path
        d="M4.39748 11.9366C4.18219 11.3166 4.05759 10.6521 4.05759 9.96565C4.05759 9.27909 4.18219 8.61473 4.38615 7.99466L4.38045 7.8626L1.19304 5.44366L1.08875 5.49214C0.397576 6.84305 0.000976562 8.36008 0.000976562 9.96565C0.000976562 11.5712 0.397576 13.0882 1.08875 14.4391L4.39748 11.9366Z"
        fill="#FBBC05"
      />
      <path
        d="M10.1993 3.85336C12.1142 3.85336 13.406 4.66168 14.1425 5.33717L17.0207 2.59107C15.253 0.985496 12.9527 0 10.1993 0C6.2106 0 2.76588 2.23672 1.08887 5.49214L4.38626 7.99466C5.21352 5.59183 7.50242 3.85336 10.1993 3.85336Z"
        fill="#EB4335"
      />
    </svg>
  );
};

export const Users = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon points="0 0 24 0 24 24 0 24"></polygon>
        <path
          d="M18,14 C16.3431458,14 15,12.6568542 15,11 C15,9.34314575 16.3431458,8 18,8 C19.6568542,8 21,9.34314575 21,11 C21,12.6568542 19.6568542,14 18,14 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.3"
        ></path>
        <path
          d="M17.6011961,15.0006174 C21.0077043,15.0378534 23.7891749,16.7601418 23.9984937,20.4 C24.0069246,20.5466056 23.9984937,21 23.4559499,21 L19.6,21 C19.6,18.7490654 18.8562935,16.6718327 17.6011961,15.0006174 Z M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z"
          fill="#000000"
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  );
};

export const MakeActivate = () => {
  return (
    <span className="svg-icon svg-icon-md svg-icon-success">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // xmlns:xlink="http://www.w3.org/1999/xlink"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24"></polygon>
          <path
            d="M9.26193932,16.6476484 C8.90425297,17.0684559 8.27315905,17.1196257 7.85235158,16.7619393 C7.43154411,16.404253 7.38037434,15.773159 7.73806068,15.3523516 L16.2380607,5.35235158 C16.6013618,4.92493855 17.2451015,4.87991302 17.6643638,5.25259068 L22.1643638,9.25259068 C22.5771466,9.6195087 22.6143273,10.2515811 22.2474093,10.6643638 C21.8804913,11.0771466 21.2484189,11.1143273 20.8356362,10.7474093 L17.0997854,7.42665306 L9.26193932,16.6476484 Z"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.3"
            transform="translate(14.999995, 11.000002) rotate(-180.000000) translate(-14.999995, -11.000002) "
          ></path>
          <path
            d="M4.26193932,17.6476484 C3.90425297,18.0684559 3.27315905,18.1196257 2.85235158,17.7619393 C2.43154411,17.404253 2.38037434,16.773159 2.73806068,16.3523516 L11.2380607,6.35235158 C11.6013618,5.92493855 12.2451015,5.87991302 12.6643638,6.25259068 L17.1643638,10.2525907 C17.5771466,10.6195087 17.6143273,11.2515811 17.2474093,11.6643638 C16.8804913,12.0771466 16.2484189,12.1143273 15.8356362,11.7474093 L12.0997854,8.42665306 L4.26193932,17.6476484 Z"
            fill="#000000"
            fillRule="nonzero"
            transform="translate(9.999995, 12.000002) rotate(-180.000000) translate(-9.999995, -12.000002) "
          ></path>
        </g>
      </svg>
    </span>
  );
};

export const MakeDeactivate = () => {
  return (
    <span className="svg-icon svg-icon-md svg-icon-danger">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // xmlns:xlink="http://www.w3.org/1999/xlink"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g
            transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)"
            fill="#000000"
          >
            <rect x="0" y="7" width="16" height="2" rx="1"></rect>
            <rect
              opacity="0.3"
              transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000) "
              x="0"
              y="7"
              width="16"
              height="2"
              rx="1"
            ></rect>
          </g>
        </g>
      </svg>
    </span>
  );
};

export const ChangePassword = () => {
  return (
    <span className="svg-icon svg-icon-md svg-icon-primary">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-person"
        viewBox="0 0 16 16"
      >
        <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"></path>
      </svg>
    </span>
  );
};
// export const InventoryReports = () => {
//   return (
//   <span className="svg-icon svg-icon-md svg-icon-primary">
//   <svg
//   xmlns="http://www.w3.org/2000/svg"
//   width="16"
//   height="16"
//   fill="currentColor"
//   className="bi bi-window"
//   viewBox="0 0 16 16"

//   >
//   <path d="M2.5 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zm2-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm1 .5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
//   <path d="M2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H2zm13 2v2H1V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zM2 14a1 1 0 0 1-1-1V6h14v7a1 1 0 0 1-1 1H2z" />
//   </svg>
//   </span>
//   );
//   };
export const SendCreds = () => {
  return (
    <span className="svg-icon svg-icon-primary svg-icon-2x">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // xmlns:xlink="http://www.w3.org/1999/xlink"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <rect x="0" y="0" width="24" height="24"></rect>
          <path
            d="M14,13.381038 L14,3.47213595 L7.99460483,15.4829263 L14,13.381038 Z M4.88230018,17.2353996 L13.2844582,0.431083506 C13.4820496,0.0359007077 13.9625881,-0.12427877 14.3577709,0.0733126292 C14.5125928,0.15072359 14.6381308,0.276261584 14.7155418,0.431083506 L23.1176998,17.2353996 C23.3152912,17.6305824 23.1551117,18.1111209 22.7599289,18.3087123 C22.5664522,18.4054506 22.3420471,18.4197165 22.1378777,18.3482572 L14,15.5 L5.86212227,18.3482572 C5.44509941,18.4942152 4.98871325,18.2744737 4.84275525,17.8574509 C4.77129597,17.6532815 4.78556182,17.4288764 4.88230018,17.2353996 Z"
            fill="#000000"
            fillRule="nonzero"
            transform="translate(14.000087, 9.191034) rotate(-315.000000) translate(-14.000087, -9.191034) "
          ></path>
        </g>
      </svg>
    </span>
  );
};

export const Seeker = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      enableBackground="new 0 0 1000 1000"
      // xml:space="preserve"
    >
      <g>
        <path d="M500,990C229.8,990,10,770.2,10,500C10,229.8,229.8,10,500,10c270.2,0,490,219.8,490,490C990,770.2,770.2,990,500,990z M500,56.7C255.5,56.7,56.7,255.5,56.7,500c0,244.5,198.9,443.3,443.3,443.3c244.5,0,443.3-198.9,443.3-443.3C943.3,255.5,744.5,56.7,500,56.7z" />
        <path d="M646.9,229.6" />
        <path d="M457.1,738.1H285.3c-12.9,0-23.3-10.4-23.3-23.3V543c0-6.2,2.5-12.1,6.8-16.5l343.6-343.6c8.8-8.7,24.2-8.7,33,0l171.8,171.8c9.1,9.1,9.1,23.9,0,33l-67.8,67.8c-9.1,9.1-23.9,9.1-33,0L593,332.2c-9.1-9.1-9.1-23.9,0-33c9.1-9.1,23.9-9.1,33,0L732.8,406l34.8-34.8L628.8,232.4L308.6,552.6v138.8h138.8l214.8-214.8c9.1-9.1,23.9-9.1,33,0c9.1,9.1,9.1,23.9,0,33L473.6,731.2C469.2,735.6,463.2,738.1,457.1,738.1z" />
      </g>
    </svg>
  );
};

export const Creator = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      enableBackground="new 0 0 1000 1000"
      // xml:space="preserve"
    >
      <g>
        <path d="M731.2,75.6c-219.4,4.6-301.8,177.8-301.8,177.8c-25-30.4-86.1-76.5-190.3-70.7c-96.3,5.4-142.7,48.2-178.3,96.4C-45.1,422.2,2.8,572.6,317.9,830.4c18.4,15.1,56.1,21.2,74.5,5.6c16.9-14.3,40.3-62.5-17.8-110.9c-150.7-125.7-227.3-209.9-164.2-254c49.3-34.4,83,127,237.3,127c163.1,0,242.5-208.6,292-217.7c81.7-15,56.9,119.5-73,272.1c-38.9,45.7-100.4,93.7-154.7,138.9c-41.3,34.3-77.6,46.6-85.1,75.9C416,909,446.1,921,477,924.4c8.6,0.3,17.7-0.8,27.3-3.1c23.2-5.5,48.4-20.4,86.2-42c163.6-94,392.1-286,399.3-496.6C995.1,227.3,900.6,72,731.2,75.6z M456.7,525.6c-45.4,0-82.1-36.6-82.1-81.6c0-45.1,36.8-81.6,82.1-81.6c45.3,0,82.1,36.6,82.1,81.6C538.9,489,502.1,525.6,456.7,525.6z" />
      </g>
    </svg>
  );
};

export const HelpCentre = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      enableBackground="new 0 0 1000 1000"
      // xml:space="preserve"
    >
      <g>
        <g transform="translate(0.000000,511.000000) scale(0.100000,-0.100000)">
          <path d="M4597.4,4993c-92.1-9.8-268.5-41.2-392-68.6c-1264.1-284.2-2285.1-1230.8-2655.5-2465.4c-119.5-395.9-139.1-552.7-139.1-1099.5c2-507.6,21.6-703.6,111.7-1117.1C1887-1433.2,3060.9-3204.9,4752.2-4627.7c245-205.8,227.3-201.9,395.9-66.6C6427.8-3661.5,7572.4-2183.8,8117.2-857c429.2,1044.6,576.2,2146,397.8,2998.5C8238.7,3480,7211.8,4559.8,5898.7,4896.9C5520.5,4994.9,4965.8,5036.1,4597.4,4993z M5420.5,4218.8c531.1-90.2,1038.7-344.9,1434.6-713.4c339-317.5,595.8-709.5,742.8-1136.7c92.1-264.6,133.3-493.9,147-803.5c31.4-811.3-254.8-1534.5-832.9-2108.7c-392-388-899.6-654.6-1464-764.3c-243-49-756.5-49-999.5,0C3292.2-1080.5,2441.6-239.7,2190.7,920.5c-50.9,233.2-49,840.7,2,1075.9c123.5,570.3,368.4,1023,776.1,1432.6c456.6,456.6,960.3,709.4,1626.6,809.4C4740.4,4260,5252,4248.2,5420.5,4218.8z" />
          <path d="M5957.5,3109.6c-211.7-111.7-515.4-515.4-580.1-770.2l-23.5-92.1l150.9-150.9c147-147,148.9-150.9,148.9-248.9c0-141.1-99.9-329.2-290-546.8c-309.6-354.7-676.1-640.9-876-684c-58.8-11.8-64.7-5.9-172.5,152.9c-129.4,188.1-182.3,219.5-341,196c-147-19.6-386.1-119.6-546.8-227.3c-182.3-121.5-243-215.6-243-376.3c0-192.1,31.4-276.3,143.1-374.3c115.6-105.8,401.8-250.9,582.1-297.9l127.4-31.3l215.6,109.7c252.8,129.4,621.3,366.5,840.8,540.9C5681.2,779.4,6425.9,1704.4,6625.8,2214l52.9,135.2l-33.3,123.5c-76.4,272.4-221.4,501.7-393.9,621.3C6149.6,3164.5,6069.2,3168.4,5957.5,3109.6z" />
        </g>
      </g>
    </svg>
  );
};

export const Tutorials = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      enableBackground="new 0 0 1000 1000"
      // xml:space="preserve"
    >
      <path d="M448.4,397.8c-45.5,28.5-59.4,88.7-30.8,134.3c28.4,45.6,88.6,59.4,134.1,30.9c45.6-28.4,59.5-88.5,31-134.2C554.2,383.2,494,369.3,448.4,397.8z" />
      <path d="M872.9,729.3c21.8-8.8,37.2-30.1,37.2-55V267c0-32.8-26.6-59.4-59.4-59.4H149.3c-32.8,0-59.4,26.7-59.4,59.4v407.3c0,24.9,15.4,46.1,37.2,55H10c0,50.1,19.5,63.1,43.4,63.1h893.2c23.9,0,43.4-13,43.4-63.1H872.9z M590.6,764.4H409.5v-30.7h181.1V764.4z M664.2,546.1l-33.6-7.8c-7.6,17.3-18.9,33.3-33.3,46.5l18.4,29.3l-46,28.8l-18.3-29.3c-18.3,7.1-37.6,10.2-56.5,9.5l-7.7,33.7l-52.8-12.3l7.7-33.6c-17.3-7.6-33.1-18.8-46.5-33.3L366.2,596l-28.8-46.1l29.3-18.3c-7-18.5-10.2-37.5-9.5-56.5l-33.7-7.7l12.3-52.9l33.6,7.8c7.6-17.4,18.9-33.2,33.3-46.5l-18.3-29.4l45.9-28.7l18.3,29.4c18.4-7,37.5-10.2,56.5-9.4L513,304l52.8,12.1l-7.7,33.6c17.3,7.7,33.1,18.9,46.5,33.3l29.3-18.4l28.7,46.1l-29.3,18.3c7,18.3,10.1,37.5,9.4,56.4l33.7,7.7L664.2,546.1z" />
    </svg>
  );
};

export const Category = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // xmlns:xlink="http://www.w3.org/1999/xlink"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24" />
        <rect fill="#000000" x="4" y="4" width="7" height="7" rx="1.5" />
        <path
          d="M5.5,13 L9.5,13 C10.3284271,13 11,13.6715729 11,14.5 L11,18.5 C11,19.3284271 10.3284271,20 9.5,20 L5.5,20 C4.67157288,20 4,19.3284271 4,18.5 L4,14.5 C4,13.6715729 4.67157288,13 5.5,13 Z M14.5,4 L18.5,4 C19.3284271,4 20,4.67157288 20,5.5 L20,9.5 C20,10.3284271 19.3284271,11 18.5,11 L14.5,11 C13.6715729,11 13,10.3284271 13,9.5 L13,5.5 C13,4.67157288 13.6715729,4 14.5,4 Z M14.5,13 L18.5,13 C19.3284271,13 20,13.6715729 20,14.5 L20,18.5 C20,19.3284271 19.3284271,20 18.5,20 L14.5,20 C13.6715729,20 13,19.3284271 13,18.5 L13,14.5 C13,13.6715729 13.6715729,13 14.5,13 Z"
          fill="#000000"
          opacity="0.3"
        />
      </g>
    </svg>
  );
};

export const Review = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="478.248px"
      height="478.248px"
      viewBox="0 0 478.248 478.248"
      // style="enable-background:new 0 0 478.248 478.248;"
      enableBackground="new 0 0 478.248 478.248"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <g>
            <path
              d="M456.02,44.821H264.83c-12.26,0-22.232,9.972-22.232,22.229v98.652c0,12.258,9.974,22.23,22.232,22.23h16.787v39.161
				c0,2.707,1.58,5.165,4.043,6.292c0.92,0.42,1.901,0.627,2.875,0.627c1.631,0,3.244-0.576,4.523-1.685l51.383-44.396h111.576
				c12.26,0,22.23-9.973,22.23-22.23V67.05C478.25,54.792,468.277,44.821,456.02,44.821z M319.922,112.252l-10.209,9.953
				l2.41,14.054c0.174,1.015-0.242,2.038-1.076,2.643c-0.469,0.342-1.027,0.516-1.588,0.516c-0.428,0-0.861-0.103-1.256-0.31
				l-12.621-6.635l-12.619,6.635c-0.912,0.478-2.016,0.398-2.848-0.206s-1.248-1.628-1.074-2.643l2.41-14.054l-10.211-9.953
				c-0.734-0.718-1.002-1.792-0.685-2.769c0.317-0.978,1.164-1.691,2.183-1.839l14.11-2.05l6.31-12.786
				c0.457-0.923,1.396-1.507,2.424-1.507s1.969,0.584,2.422,1.507l6.312,12.786l14.107,2.05c1.02,0.148,1.863,0.861,2.184,1.839
				C320.924,110.46,320.658,111.535,319.922,112.252z M384.766,112.252l-10.211,9.953l2.412,14.054
				c0.172,1.015-0.244,2.038-1.076,2.643c-0.469,0.342-1.025,0.516-1.588,0.516c-0.43,0-0.859-0.103-1.26-0.31l-12.619-6.635
				l-12.619,6.635c-0.912,0.478-2.014,0.398-2.846-0.206c-0.834-0.604-1.25-1.628-1.076-2.643l2.41-14.054l-10.209-9.953
				c-0.734-0.718-1.002-1.792-0.684-2.769c0.316-0.978,1.16-1.691,2.182-1.839l14.109-2.05l6.311-12.786
				c0.455-0.923,1.396-1.507,2.422-1.507c1.029,0,1.967,0.584,2.422,1.507l6.312,12.786l14.109,2.05
				c1.021,0.148,1.863,0.861,2.182,1.839C385.768,110.46,385.5,111.535,384.766,112.252z M449.607,112.252l-10.211,9.953
				l2.408,14.054c0.176,1.015-0.238,2.038-1.072,2.643c-0.471,0.342-1.027,0.516-1.59,0.516c-0.43,0-0.859-0.103-1.258-0.31
				l-12.621-6.635l-12.621,6.635c-0.908,0.478-2.012,0.398-2.844-0.206c-0.834-0.604-1.248-1.628-1.076-2.643l2.412-14.054
				l-10.211-9.953c-0.734-0.718-1-1.792-0.684-2.769c0.316-0.978,1.164-1.691,2.182-1.839l14.111-2.05l6.311-12.786
				c0.453-0.923,1.395-1.507,2.42-1.507c1.027,0,1.971,0.584,2.426,1.507L434,105.594l14.109,2.05
				c1.018,0.148,1.861,0.861,2.182,1.839C450.609,110.46,450.344,111.535,449.607,112.252z"
            />
            <path
              d="M152.844,112.924c-46.76,0-72.639,24.231-72.166,70.921c0.686,63.947,27.859,102.74,72.166,102.063
				c0,0,72.131,2.924,72.131-102.063C224.975,137.155,200.605,112.924,152.844,112.924z"
            />
            <path
              d="M280.428,334.444l-72.074-28.736l-16.877-14.223c-4.457-3.766-11.041-3.488-15.178,0.621l-23.463,23.336l-23.533-23.342
				c-4.137-4.104-10.713-4.369-15.164-0.615l-16.881,14.223l-72.074,28.739C1.975,343.69,1.995,425.884,0,433.427h305.646
				C303.656,425.9,303.646,343.679,280.428,334.444z"
            />
          </g>
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};

export const Order = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      enableBackground="new 0 0 512 512"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <polygon
            points="153.106,312.121 153.106,512 168.717,512 168.717,327.731 345.18,327.731 345.18,512 360.791,512 
			360.791,312.121 		"
          />
        </g>
      </g>
      <g>
        <g>
          <polygon points="295.548,386.072 295.548,512 311.158,512 311.158,401.683 319.484,401.683 319.484,386.072 		" />
        </g>
      </g>
      <g>
        <g>
          <polygon points="192.516,386.072 192.516,401.683 200.842,401.683 200.842,512 216.452,512 216.452,386.072 		" />
        </g>
      </g>
      <g>
        <g>
          <path d="M209.127,128.05v167.669h95.642V128.05H209.127z M289.157,280.108h-64.42V143.661h0h64.42V280.108z" />
        </g>
      </g>
      <g>
        <g>
          <polygon points="368.398,360.054 368.398,375.665 488.082,375.665 488.082,512 503.692,512 503.692,360.054 		" />
        </g>
      </g>
      <g>
        <g>
          <polygon points="447.493,417.294 447.493,512 463.104,512 463.104,432.905 472.471,432.905 472.471,417.294 		" />
        </g>
      </g>
      <g>
        <g>
          <polygon points="368.398,417.294 368.398,432.905 376.724,432.905 376.724,512 392.335,512 392.335,417.294 		" />
        </g>
      </g>
      <g>
        <g>
          <path d="M393.199,240.092v103.646h55.626V240.092H393.199z M433.214,328.127H408.81v-72.424h24.404V328.127z" />
        </g>
      </g>
      <g>
        <g>
          <polygon points="8.308,360.054 8.308,512 23.918,512 23.918,375.665 143.602,375.665 143.602,360.054 		" />
        </g>
      </g>
      <g>
        <g>
          <polygon points="40.57,417.294 40.57,432.905 47.855,432.905 47.855,512 63.466,512 63.466,417.294 		" />
        </g>
      </g>
      <g>
        <g>
          <polygon points="120.706,417.294 120.706,512 136.317,512 136.317,432.905 143.602,432.905 143.602,417.294 		" />
        </g>
      </g>
      <g>
        <g>
          <path d="M65.072,240.092v103.646h55.627V240.092H65.072z M105.088,328.127H80.683v-72.424h24.405V328.127z" />
        </g>
      </g>
      <g>
        <g>
          <rect x="249.754" y="337.153" width="15.611" height="15.611" />
        </g>
      </g>
      <g>
        <g>
          <rect x="249.754" y="360.049" width="15.611" height="86.38" />
        </g>
      </g>
      <g>
        <g>
          <rect x="216.45" y="41.593" width="15.611" height="15.611" />
        </g>
      </g>
      <g>
        <g>
          <rect x="249.754" y="41.593" width="15.611" height="15.611" />
        </g>
      </g>
      <g>
        <g>
          <rect x="280.975" y="41.593" width="15.611" height="15.611" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M344.785,41.593V0H169.112v41.593h-16.144v15.611h16.144v38.438h61.467l26.369,17.583l26.37-17.583h61.467V57.203h15.288
			V41.593H344.785z M329.173,80.031H278.59l-21.643,14.43l-21.641-14.43h-50.583v-64.42h144.45V80.031z"
          />
        </g>
      </g>
      <g>
        <g>
          <polygon
            points="143.602,57.203 143.602,41.593 88.443,41.593 88.443,190.161 78.396,180.112 67.357,191.152 95.846,220.68 
			125.375,191.151 115.375,180.113 104.054,191.435 104.054,57.203 		"
          />
        </g>
      </g>
      <g>
        <g>
          <polygon
            points="434.458,182.194 423.557,193.097 423.557,41.593 368.398,41.593 368.398,57.203 407.946,57.203 407.946,192.662 
			397.479,182.193 386.439,193.233 415.969,222.762 445.497,193.232 		"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};

export const Transactions = () => {
  return (
    <svg
      version="1.2"
      baseProfile="tiny"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 256 256"
      xmlSpace="preserve"
    >
      <path
        id="XMLID_11_"
        d="M57.9,41.9c11.3,0,20.5-9.2,20.5-20.5c0-11.3-9.2-20.5-20.5-20.5c-11.3,0-20.5,9.2-20.5,20.5
	C37.4,32.7,46.6,41.9,57.9,41.9"
      />
      <path
        id="XMLID_10_"
        d="M203.4,41.6c11.5,0,20.8-9.3,20.8-20.8c0-11.5-9.3-20.8-20.8-20.8c-11.5,0-20.8,9.3-20.8,20.8
	C182.6,32.3,191.9,41.6,203.4,41.6"
      />
      <path
        id="XMLID_7_"
        d="M50.3,158.5c-26.9,0-48.7,21.8-48.7,48.7c0,26.9,21.8,48.8,48.7,48.8c26.9,0,48.8-21.8,48.8-48.8
	C99.1,180.3,77.2,158.5,50.3,158.5 M56.1,238.2v7.8H44.4v-7.8c-12.4-1.4-20.4-13.3-20.4-21h12.4c0,3.5,2.7,8.1,8,9.2v-14.6
	c-2.7-0.5-4.2-0.9-7.1-1.7c-7.3-2-12.4-8.2-12.4-16.1c0-7.8,7.6-16.6,19.4-18.1v-7.3h11.7v7.3c12.5,1.6,20.1,10.8,20.1,20l-12.2,0
	c0-4-3.4-7.7-8-8.1v13.7c3.4,0.7,3.4,0.7,6.5,1.5c11.6,3.2,14.2,10.7,14.2,17.1C76.8,229.8,69,236.5,56.1,238.2"
      />
      <path
        id="XMLID_4_"
        d="M44.4,199.3c-5.2-0.9-6.6-3.2-6.6-5.6c0-2.8,3.5-5.5,6.6-5.9V199.3z M56.2,226.3V214c5.1,0.7,8.4,3,8.4,6.1
	C64.6,222.9,61.6,226.1,56.2,226.3"
      />
      <path
        id="XMLID_3_"
        d="M31.2,77.4h8.1l-9.3,34.7h56l-9.3-34.7h8.1l9.6,34.7h18L100.6,70c-3.1-10.2-13.2-21-26.4-21H41.5
	c-13.2,0-23.3,10.8-26.4,21L3.6,112.1h18L31.2,77.4z"
      />
      <path
        id="XMLID_2_"
        d="M225.6,48.8c10.2,0,18.5,8.3,18.5,18.5l0,56.8H256v23.3l-24.1,0v96.4c0,6.7-5.5,12.2-12.3,12.2
	c-6.7,0-12.2-5.5-12.2-12.2v-96.4h-7.8v96.4c0,6.7-5.5,12.2-12.2,12.2c-6.7,0-12.2-5.5-12.2-12.2v-96.4L1.6,147.4v-23.4h173.6V69.4
	l-38.8,46c-8.2,9.4-22.7-2.4-14.5-12.4l40.2-48.4c2.6-2.6,4.9-5.8,14.5-5.8H225.6z"
      />
    </svg>
  );
};

export const Reports = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 463 463"
      enable-background="new 0 0 463 463"
      xmlSpace="preserve"
    >
      <g>
        <path
          d="M367.5,32h-57.734c-3.138-9.29-11.93-16-22.266-16h-24.416c-7.41-9.965-19.148-16-31.584-16
		c-12.435,0-24.174,6.035-31.585,16H175.5c-10.336,0-19.128,6.71-22.266,16H95.5C78.131,32,64,46.131,64,63.5v368
		c0,17.369,14.131,31.5,31.5,31.5h272c17.369,0,31.5-14.131,31.5-31.5v-368C399,46.131,384.869,32,367.5,32z M175.5,87h112
		c7.023,0,13.332-3.101,17.641-8H352v337H111V79h46.859C162.168,83.899,168.477,87,175.5,87z M175.5,31h28.438
		c2.67,0,5.139-1.419,6.482-3.727C214.893,19.588,222.773,15,231.5,15c8.728,0,16.607,4.588,21.079,12.272
		c1.343,2.308,3.813,3.728,6.482,3.728H287.5c4.687,0,8.5,3.813,8.5,8.5v24c0,4.687-3.813,8.5-8.5,8.5h-112
		c-4.687,0-8.5-3.813-8.5-8.5v-24C167,34.813,170.813,31,175.5,31z M384,431.5c0,9.098-7.402,16.5-16.5,16.5h-272
		c-9.098,0-16.5-7.402-16.5-16.5v-368C79,54.402,86.402,47,95.5,47H152v16.5c0,0.168,0.009,0.333,0.013,0.5H103.5
		c-4.143,0-7.5,3.358-7.5,7.5v352c0,4.142,3.357,7.5,7.5,7.5h256c4.143,0,7.5-3.358,7.5-7.5v-352c0-4.142-3.357-7.5-7.5-7.5h-48.513
		c0.004-0.167,0.013-0.332,0.013-0.5V47h56.5c9.098,0,16.5,7.402,16.5,16.5V431.5z"
        />
        <path
          d="M231.5,47c1.979,0,3.91-0.8,5.3-2.2c1.4-1.39,2.2-3.33,2.2-5.3c0-1.97-0.8-3.91-2.2-5.3c-1.39-1.4-3.32-2.2-5.3-2.2
		c-1.98,0-3.91,0.8-5.3,2.2c-1.4,1.39-2.2,3.32-2.2,5.3s0.8,3.91,2.2,5.3C227.59,46.2,229.52,47,231.5,47z"
        />
        <path d="M183.5,159h136c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-136c-4.143,0-7.5,3.358-7.5,7.5S179.357,159,183.5,159z" />
        <path d="M183.5,239h136c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-136c-4.143,0-7.5,3.358-7.5,7.5S179.357,239,183.5,239z" />
        <path d="M183.5,319h24c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-24c-4.143,0-7.5,3.358-7.5,7.5S179.357,319,183.5,319z" />
        <path d="M183.5,199h136c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-136c-4.143,0-7.5,3.358-7.5,7.5S179.357,199,183.5,199z" />
        <path d="M183.5,279h32c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-32c-4.143,0-7.5,3.358-7.5,7.5S179.357,279,183.5,279z" />
        <path d="M183.5,359h32c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-32c-4.143,0-7.5,3.358-7.5,7.5S179.357,359,183.5,359z" />
        <path d="M143.5,159h8c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-8c-4.143,0-7.5,3.358-7.5,7.5S139.357,159,143.5,159z" />
        <path d="M143.5,239h8c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-8c-4.143,0-7.5,3.358-7.5,7.5S139.357,239,143.5,239z" />
        <path d="M143.5,319h8c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-8c-4.143,0-7.5,3.358-7.5,7.5S139.357,319,143.5,319z" />
        <path d="M143.5,199h8c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-8c-4.143,0-7.5,3.358-7.5,7.5S139.357,199,143.5,199z" />
        <path d="M143.5,279h8c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-8c-4.143,0-7.5,3.358-7.5,7.5S139.357,279,143.5,279z" />
        <path d="M143.5,359h8c4.143,0,7.5-3.358,7.5-7.5s-3.357-7.5-7.5-7.5h-8c-4.143,0-7.5,3.358-7.5,7.5S139.357,359,143.5,359z" />
        <path
          d="M279.5,264c-26.191,0-47.5,21.309-47.5,47.5s21.309,47.5,47.5,47.5c10.583,0,20.367-3.482,28.272-9.357
		c0.074-0.052,0.155-0.088,0.228-0.143c0.2-0.15,0.389-0.309,0.57-0.474C319.771,340.329,327,326.747,327,311.5
		C327,285.309,305.691,264,279.5,264z M272,279.883V304h-24.117C250.708,292.094,260.094,282.708,272,279.883z M247.883,319h27.867
		l16.719,22.292c-3.976,1.737-8.36,2.708-12.969,2.708C264.161,344,251.279,333.315,247.883,319z M304.463,332.284L287,309v-29.117
		c14.315,3.396,25,16.278,25,31.617C312,319.398,309.165,326.646,304.463,332.284z"
        />
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};

export const Wallet = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="28"
      viewBox="0 0 31 28"
      fill="none"
    >
      <path
        d="M27.125 6.22222H24.8V4.66667C24.7988 3.42937 24.3085 2.2431 23.4367 1.3682C22.5649 0.493298 21.3829 0.00123545 20.15 0H3.875C2.84754 0.000823927 1.86239 0.41081 1.13587 1.13994C0.409342 1.86907 0.000820985 2.85774 0 3.88889V23.3333C0.00123103 24.5706 0.491536 25.7569 1.36331 26.6318C2.23509 27.5067 3.41712 27.9988 4.65 28H27.125C28.1525 27.9992 29.1376 27.5892 29.8641 26.8601C30.5907 26.1309 30.9992 25.1423 31 24.1111V10.1111C30.9992 9.07997 30.5907 8.09129 29.8641 7.36216C29.1376 6.63303 28.1525 6.22305 27.125 6.22222ZM3.875 1.55556H20.15C20.9718 1.55679 21.7596 1.88496 22.3407 2.46814C22.9218 3.05132 23.2488 3.84193 23.25 4.66667V6.22222H3.875C3.56968 6.22222 3.26734 6.16187 2.98526 6.04461C2.70318 5.92735 2.44687 5.75548 2.23098 5.53881C2.01508 5.32213 1.84382 5.06491 1.72698 4.78182C1.61014 4.49872 1.55 4.19531 1.55 3.88889C1.55 3.58247 1.61014 3.27905 1.72698 2.99596C1.84382 2.71287 2.01508 2.45564 2.23098 2.23897C2.44687 2.0223 2.70318 1.85043 2.98526 1.73317C3.26734 1.61591 3.56968 1.55556 3.875 1.55556ZM29.45 20.2222H26.35C25.5278 20.2222 24.7393 19.8944 24.158 19.311C23.5766 18.7276 23.25 17.9362 23.25 17.1111C23.25 16.286 23.5766 15.4947 24.158 14.9112C24.7393 14.3278 25.5278 14 26.35 14H29.45V20.2222ZM29.45 12.4444H26.35C25.7394 12.4444 25.1347 12.5652 24.5705 12.7997C24.0064 13.0342 23.4937 13.3779 23.062 13.8113C22.6302 14.2446 22.2876 14.7591 22.054 15.3253C21.8203 15.8914 21.7 16.4983 21.7 17.1111C21.7 17.7239 21.8203 18.3308 22.054 18.897C22.2876 19.4632 22.6302 19.9776 23.062 20.4109C23.4937 20.8443 24.0064 21.188 24.5705 21.4226C25.1347 21.6571 25.7394 21.7778 26.35 21.7778H29.45V24.1111C29.45 24.7299 29.205 25.3234 28.769 25.761C28.333 26.1986 27.7416 26.4444 27.125 26.4444H4.65C3.82821 26.4432 3.04042 26.115 2.45933 25.5319C1.87823 24.9487 1.55123 24.1581 1.55 23.3333V6.99844C2.2196 7.50556 3.03645 7.77933 3.875 7.77778H27.125C27.7416 7.77778 28.333 8.02361 28.769 8.46119C29.205 8.89878 29.45 9.49227 29.45 10.1111V12.4444Z"
        fill="currentcolor"
      />
    </svg>
  );
};

export const Payout = () => {
  return (
    <span class="svg-icon svg-icon-primary svg-icon-2x">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        fill="none"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <rect x="0" y="0" width="24" height="24" />
          <path
            d="M22,17 L22,21 C22,22.1045695 21.1045695,23 20,23 L4,23 C2.8954305,23 2,22.1045695 2,21 L2,17 L6.27924078,17 L6.82339262,18.6324555 C7.09562072,19.4491398 7.8598984,20 8.72075922,20 L15.381966,20 C16.1395101,20 16.8320364,19.5719952 17.1708204,18.8944272 L18.118034,17 L22,17 Z"
            fill="#000000"
          />
          <path
            d="M2.5625,15 L5.92654389,9.01947752 C6.2807805,8.38972356 6.94714834,8 7.66969497,8 L16.330305,8 C17.0528517,8 17.7192195,8.38972356 18.0734561,9.01947752 L21.4375,15 L18.118034,15 C17.3604899,15 16.6679636,15.4280048 16.3291796,16.1055728 L15.381966,18 L8.72075922,18 L8.17660738,16.3675445 C7.90437928,15.5508602 7.1401016,15 6.27924078,15 L2.5625,15 Z"
            fill="#000000"
            opacity="0.3"
          />
          <path
            d="M11.1288761,0.733697713 L11.1288761,2.69017121 L9.12120481,2.69017121 C8.84506244,2.69017121 8.62120481,2.91402884 8.62120481,3.19017121 L8.62120481,4.21346991 C8.62120481,4.48961229 8.84506244,4.71346991 9.12120481,4.71346991 L11.1288761,4.71346991 L11.1288761,6.66994341 C11.1288761,6.94608579 11.3527337,7.16994341 11.6288761,7.16994341 C11.7471877,7.16994341 11.8616664,7.12798964 11.951961,7.05154023 L15.4576222,4.08341738 C15.6683723,3.90498251 15.6945689,3.58948575 15.5161341,3.37873564 C15.4982803,3.35764848 15.4787093,3.33807751 15.4576222,3.32022374 L11.951961,0.352100892 C11.7412109,0.173666017 11.4257142,0.199862688 11.2472793,0.410612793 C11.1708299,0.500907473 11.1288761,0.615386087 11.1288761,0.733697713 Z"
            fill="#000000"
            fillRule="nonzero"
            transform="translate(11.959697, 3.661508) rotate(-90.000000) translate(-11.959697, -3.661508) "
          />
        </g>
      </svg>
    </span>
  );
};

export const Courses = () => {
  return (
    <span class="svg-icon svg-icon-primary svg-icon-2x">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        fill="none"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <rect x="0" y="0" width="24" height="24" />
          <path
            d="M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z"
            fill="#000000"
            opacity="0.3"
          />
          <path
            d="M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z"
            fill="#000000"
          />
          <rect
            fill="#000000"
            opacity="0.3"
            x="10"
            y="9"
            width="7"
            height="2"
            rx="1"
          />
          <rect
            fill="#000000"
            opacity="0.3"
            x="7"
            y="9"
            width="2"
            height="2"
            rx="1"
          />
          <rect
            fill="#000000"
            opacity="0.3"
            x="7"
            y="13"
            width="2"
            height="2"
            rx="1"
          />
          <rect
            fill="#000000"
            opacity="0.3"
            x="10"
            y="13"
            width="7"
            height="2"
            rx="1"
          />
          <rect
            fill="#000000"
            opacity="0.3"
            x="7"
            y="17"
            width="2"
            height="2"
            rx="1"
          />
          <rect
            fill="#000000"
            opacity="0.3"
            x="10"
            y="17"
            width="7"
            height="2"
            rx="1"
          />
        </g>
      </svg>
    </span>
  );
};

export const Creators = () => {
  return (
    <span class="svg-icon svg-icon-primary svg-icon-2x">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        fill="none"
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <rect x="0" y="0" width="24" height="24" />
          <rect
            fill="#000000"
            opacity="0.3"
            x="4"
            y="4"
            width="4"
            height="4"
            rx="1"
          />
          <path
            d="M5,10 L7,10 C7.55228475,10 8,10.4477153 8,11 L8,13 C8,13.5522847 7.55228475,14 7,14 L5,14 C4.44771525,14 4,13.5522847 4,13 L4,11 C4,10.4477153 4.44771525,10 5,10 Z M11,4 L13,4 C13.5522847,4 14,4.44771525 14,5 L14,7 C14,7.55228475 13.5522847,8 13,8 L11,8 C10.4477153,8 10,7.55228475 10,7 L10,5 C10,4.44771525 10.4477153,4 11,4 Z M11,10 L13,10 C13.5522847,10 14,10.4477153 14,11 L14,13 C14,13.5522847 13.5522847,14 13,14 L11,14 C10.4477153,14 10,13.5522847 10,13 L10,11 C10,10.4477153 10.4477153,10 11,10 Z M17,4 L19,4 C19.5522847,4 20,4.44771525 20,5 L20,7 C20,7.55228475 19.5522847,8 19,8 L17,8 C16.4477153,8 16,7.55228475 16,7 L16,5 C16,4.44771525 16.4477153,4 17,4 Z M17,10 L19,10 C19.5522847,10 20,10.4477153 20,11 L20,13 C20,13.5522847 19.5522847,14 19,14 L17,14 C16.4477153,14 16,13.5522847 16,13 L16,11 C16,10.4477153 16.4477153,10 17,10 Z M5,16 L7,16 C7.55228475,16 8,16.4477153 8,17 L8,19 C8,19.5522847 7.55228475,20 7,20 L5,20 C4.44771525,20 4,19.5522847 4,19 L4,17 C4,16.4477153 4.44771525,16 5,16 Z M11,16 L13,16 C13.5522847,16 14,16.4477153 14,17 L14,19 C14,19.5522847 13.5522847,20 13,20 L11,20 C10.4477153,20 10,19.5522847 10,19 L10,17 C10,16.4477153 10.4477153,16 11,16 Z M17,16 L19,16 C19.5522847,16 20,16.4477153 20,17 L20,19 C20,19.5522847 19.5522847,20 19,20 L17,20 C16.4477153,20 16,19.5522847 16,19 L16,17 C16,16.4477153 16.4477153,16 17,16 Z"
            fill="#000000"
          />
        </g>
      </svg>
    </span>
  );
};

export const Read = () => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 103.12 122.88"
    >
      {/* <title>View Lessons</title> */}
      <rect x="0" y="0" width="24" height="24" />
      <path
        d="M36.09,34.45a3.15,3.15,0,0,1,0-6.28H76.37a3.15,3.15,0,0,1,0,6.28ZM16.43,90a5.79,5.79,0,1,1-4.86,8.94H8.82v13.36a1.91,1.91,0,0,0,1.9,1.9H91.1a1.91,1.91,0,0,0,1.34-.56,1.87,1.87,0,0,0,.56-1.34V7.12a1.9,1.9,0,0,0-.55-1.34,1.93,1.93,0,0,0-1.35-.56H10.72a1.89,1.89,0,0,0-1.9,1.9V20.48h2.75a5.8,5.8,0,1,1,0,6.29H8.82V44.53h2.75a5.8,5.8,0,1,1,0,6.29H8.82V68.58h2.75a5.79,5.79,0,1,1,0,6.29H8.82V92.63h2.75A5.79,5.79,0,0,1,16.43,90ZM3.14,98.92a3.15,3.15,0,0,1,0-6.29H3.6V74.87H3.14a3.15,3.15,0,0,1,0-6.29H3.6V50.82H3.14a3.15,3.15,0,0,1,0-6.29H3.6V26.77H3.14a3.15,3.15,0,0,1,0-6.29H3.6V7.12a7.09,7.09,0,0,1,2.09-5h0a7.07,7.07,0,0,1,5-2.09H91.1a7.07,7.07,0,0,1,5,2.09h0A7.1,7.1,0,0,1,98,5.44h.6a4.55,4.55,0,0,1,4.5,4.51V118.37a4.53,4.53,0,0,1-4.5,4.51H16.76a4.51,4.51,0,0,1-4.39-3.48H10.72a7.14,7.14,0,0,1-7.12-7.12V98.92Zm33-7.69a3.15,3.15,0,0,1,0-6.29H76.37a3.15,3.15,0,0,1,0,6.29Zm0-18.92a3.15,3.15,0,0,1,0-6.29H76.37a3.15,3.15,0,0,1,0,6.29Zm0-18.93a3.15,3.15,0,0,1,0-6.29H76.37a3.15,3.15,0,0,1,0,6.29Z"
        fill="#000000"
      />
    </svg>
  );
};

export const CustomerManagement = () => {
  return (
    <span className="svg-icon svg-icon-primary svg-icon-2x">
      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M18,8 L16,8 C15.4477153,8 15,7.55228475 15,7 C15,6.44771525 15.4477153,6 16,6 L18,6 L18,4 C18,3.44771525 18.4477153,3 19,3 C19.5522847,3 20,3.44771525 20,4 L20,6 L22,6 C22.5522847,6 23,6.44771525 23,7 C23,7.55228475 22.5522847,8 22,8 L20,8 L20,10 C20,10.5522847 19.5522847,11 19,11 C18.4477153,11 18,10.5522847 18,10 L18,8 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z"
            fill="#000000"
            fillRule="nonzero"
            // opacity="0.3"
          />
          <path
            d="M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z"
            fill="#000000"
            fillRule="nonzero"
          />
        </g>
      </svg>
      {/*end::Svg Icon*/}
    </span>
  );
};

export const Brandrequest = () => {
  return (

    <span className="svg-icon svg-icon-primary svg-icon-2x"><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
    <defs/>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect x="0" y="0" width="24" height="24"/>
        <path d="M12,8 L8,8 C5.790861,8 4,9.790861 4,12 L4,13 C4,14.6568542 5.34314575,16 7,16 L7,18 C4.23857625,18 2,15.7614237 2,13 L2,12 C2,8.6862915 4.6862915,6 8,6 L12,6 L12,4.72799742 C12,4.62015048 12.0348702,4.51519416 12.0994077,4.42878885 C12.264656,4.2075478 12.5779675,4.16215674 12.7992086,4.32740507 L15.656242,6.46136716 C15.6951359,6.49041758 15.7295917,6.52497737 15.7585249,6.56395854 C15.9231063,6.78569617 15.876772,7.09886961 15.6550344,7.263451 L12.798001,9.3840407 C12.7118152,9.44801079 12.607332,9.48254921 12.5,9.48254921 C12.2238576,9.48254921 12,9.25869158 12,8.98254921 L12,8 Z" fill="#000000"/>
        <path d="M12.0583175,16 L16,16 C18.209139,16 20,14.209139 20,12 L20,11 C20,9.34314575 18.6568542,8 17,8 L17,6 C19.7614237,6 22,8.23857625 22,11 L22,12 C22,15.3137085 19.3137085,18 16,18 L12.0583175,18 L12.0583175,18.9825492 C12.0583175,19.2586916 11.8344599,19.4825492 11.5583175,19.4825492 C11.4509855,19.4825492 11.3465023,19.4480108 11.2603165,19.3840407 L8.40328311,17.263451 C8.18154548,17.0988696 8.13521119,16.7856962 8.29979258,16.5639585 C8.32872576,16.5249774 8.36318164,16.4904176 8.40207551,16.4613672 L11.2591089,14.3274051 C11.48035,14.1621567 11.7936615,14.2075478 11.9589099,14.4287888 C12.0234473,14.5151942 12.0583175,14.6201505 12.0583175,14.7279974 L12.0583175,16 Z" fill="#000000" opacity="0.3"/>
    </g>
</svg></span>
  );
};

export const VendorManagement = () => {
  return (
    <span className="svg-icon svg-icon-primary svg-icon-2x">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <path
            d="M547.6 103.8L490.3 13.1C485.2 5 476.1 0 466.4 0H109.6C99.9 0 90.8 5 85.7 13.1L28.3 103.8c-29.6 46.8-3.4 111.9 51.9 119.4c4 .5 8.1 .8 12.1 .8c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.1 0 49.3-11.4 65.2-29c15.9 17.6 39.1 29 65.2 29c26.2 0 49.3-11.4 65.2-29c16 17.6 39.1 29 65.2 29c4.1 0 8.1-.3 12.1-.8c55.5-7.4 81.8-72.5 52.1-119.4zM499.7 254.9l-.1 0c-5.3 .7-10.7 1.1-16.2 1.1c-12.4 0-24.3-1.9-35.4-5.3V384H128V250.6c-11.2 3.5-23.2 5.4-35.6 5.4c-5.5 0-11-.4-16.3-1.1l-.1 0c-4.1-.6-8.1-1.3-12-2.3V384v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384 252.6c-4 1-8 1.8-12.3 2.3z"
            fill="#000000"
          />
        </g>
      </svg>
      {/*end::Svg Icon*/}
    </span>
  );
};
export const OrderManagement = () => {
  return (
    <span className="svg-icon svg-icon-primary svg-icon-2x">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <path
            d="M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272v192h238.7c-.4-2.5-.4-5-1.2-7.4zM240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zM0 224v240c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V224H0z"
            fill="#000000"
          />
        </g>
      </svg>
      {/*end::Svg Icon*/}
    </span>
  );
};

export const OrderOffer = () => {
  return (
    <span className="svg-icon svg-icon-primary svg-icon-2x">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <path
            d="M288 144a110.9 110.9 0 0 0 -31.2 5 55.4 55.4 0 0 1 7.2 27 56 56 0 0 1 -56 56 55.4 55.4 0 0 1 -27-7.2A111.7 111.7 0 1 0 288 144zm284.5 97.4C518.3 135.6 410.9 64 288 64S57.7 135.6 3.5 241.4a32.4 32.4 0 0 0 0 29.2C57.7 376.4 165.1 448 288 448s230.3-71.6 284.5-177.4a32.4 32.4 0 0 0 0-29.2zM288 400c-98.7 0-189.1-55-237.9-144C98.9 167 189.3 112 288 112s189.1 55 237.9 144C477.1 345 386.7 400 288 400z"
            fill="#000000"
          />
        </g>
      </svg>
      {/*end::Svg Icon*/}
    </span>
  );
};

export const Position = () => {
  return (
    <span className="svg-icon svg-icon-primary svg-icon-2x">
      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24" />
          <path
            d="M18,14 C16.3431458,14 15,12.6568542 15,11 C15,9.34314575 16.3431458,8 18,8 C19.6568542,8 21,9.34314575 21,11 C21,12.6568542 19.6568542,14 18,14 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.3"
          />
          <path
            d="M17.6011961,15.0006174 C21.0077043,15.0378534 23.7891749,16.7601418 23.9984937,20.4 C24.0069246,20.5466056 23.9984937,21 23.4559499,21 L19.6,21 C19.6,18.7490654 18.8562935,16.6718327 17.6011961,15.0006174 Z M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z"
            fill="#000000"
            fillRule="nonzero"
          />
        </g>
      </svg>
      {/*end::Svg Icon*/}
    </span>
  );
};
export const CarBrands = () => {
  return (
    <span className="svg-icon svg-icon-primary svg-icon-2x">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <g stroke="none" strokeWidth={1} fill="#000000" fillRule="evenodd">
          <path
            d="M135.2 117.4L109.1 192H402.9l-26.1-74.6C372.3 104.6 360.2 96 346.6 96H165.4c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32H346.6c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2V400v48c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V400H96v48c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V400 256c0-26.7 16.4-49.6 39.6-59.2zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
            fill="#000000"
          />
        </g>
      </svg>
    </span>
  );
};
export const SubAdminManagement = () => {
  return (
    <span className="svg-icon svg-icon-primary svg-icon-2x">
      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <rect x={0} y={0} width={24} height={24} />
          <path
            d="M4,4 L11.6314229,2.5691082 C11.8750185,2.52343403 12.1249815,2.52343403 12.3685771,2.5691082 L20,4 L20,13.2830094 C20,16.2173861 18.4883464,18.9447835 16,20.5 L12.5299989,22.6687507 C12.2057287,22.8714196 11.7942713,22.8714196 11.4700011,22.6687507 L8,20.5 C5.51165358,18.9447835 4,16.2173861 4,13.2830094 L4,4 Z"
            fill="#000000"
            opacity="0.3"
          />
          <path
            d="M12,11 C10.8954305,11 10,10.1045695 10,9 C10,7.8954305 10.8954305,7 12,7 C13.1045695,7 14,7.8954305 14,9 C14,10.1045695 13.1045695,11 12,11 Z"
            fill="#000000"
            opacity="0.3"
          />
          <path
            d="M7.00036205,16.4995035 C7.21569918,13.5165724 9.36772908,12 11.9907452,12 C14.6506758,12 16.8360465,13.4332455 16.9988413,16.5 C17.0053266,16.6221713 16.9988413,17 16.5815,17 C14.5228466,17 11.463736,17 7.4041679,17 C7.26484009,17 6.98863236,16.6619875 7.00036205,16.4995035 Z"
            fill="#000000"
            opacity="0.3"
          />
        </g>
      </svg>
      {/*end::Svg Icon*/}
    </span>
  );
};

export const ProductManagement = () => {
  return (
    <span className="svg-icon svg-icon-primary svg-icon-2x">
      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <rect x={0} y={0} width={24} height={24} />
          <path
            d="M12,4.56204994 L7.76822128,9.6401844 C7.4146572,10.0644613 6.7840925,10.1217854 6.3598156,9.76822128 C5.9355387,9.4146572 5.87821464,8.7840925 6.23177872,8.3598156 L11.2317787,2.3598156 C11.6315738,1.88006147 12.3684262,1.88006147 12.7682213,2.3598156 L17.7682213,8.3598156 C18.1217854,8.7840925 18.0644613,9.4146572 17.6401844,9.76822128 C17.2159075,10.1217854 16.5853428,10.0644613 16.2317787,9.6401844 L12,4.56204994 Z"
            fill="#000000"
            fillRule="nonzero"
            opacity="0.3"
          />
          <path
            d="M3.28077641,9 L20.7192236,9 C21.2715083,9 21.7192236,9.44771525 21.7192236,10 C21.7192236,10.0817618 21.7091962,10.163215 21.6893661,10.2425356 L19.5680983,18.7276069 C19.234223,20.0631079 18.0342737,21 16.6576708,21 L7.34232922,21 C5.96572629,21 4.76577697,20.0631079 4.43190172,18.7276069 L2.31063391,10.2425356 C2.17668518,9.70674072 2.50244587,9.16380623 3.03824078,9.0298575 C3.11756139,9.01002735 3.1990146,9 3.28077641,9 Z M12,12 C11.4477153,12 11,12.4477153 11,13 L11,17 C11,17.5522847 11.4477153,18 12,18 C12.5522847,18 13,17.5522847 13,17 L13,13 C13,12.4477153 12.5522847,12 12,12 Z M6.96472382,12.1362967 C6.43125772,12.2792385 6.11467523,12.8275755 6.25761704,13.3610416 L7.29289322,17.2247449 C7.43583503,17.758211 7.98417199,18.0747935 8.51763809,17.9318517 C9.05110419,17.7889098 9.36768668,17.2405729 9.22474487,16.7071068 L8.18946869,12.8434035 C8.04652688,12.3099374 7.49818992,11.9933549 6.96472382,12.1362967 Z M17.0352762,12.1362967 C16.5018101,11.9933549 15.9534731,12.3099374 15.8105313,12.8434035 L14.7752551,16.7071068 C14.6323133,17.2405729 14.9488958,17.7889098 15.4823619,17.9318517 C16.015828,18.0747935 16.564165,17.758211 16.7071068,17.2247449 L17.742383,13.3610416 C17.8853248,12.8275755 17.5687423,12.2792385 17.0352762,12.1362967 Z"
            fill="#000000"
          />
        </g>
      </svg>
      {/*end::Svg Icon*/}
    </span>
  );
};

export const WarehouseManagement = () => {
  return (
    <span className="svg-icon svg-icon-primary svg-icon-2x">
      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <rect x={0} y={0} width={24} height={24} />
          <path
            d="M13.5,21 L13.5,18 C13.5,17.4477153 13.0522847,17 12.5,17 L11.5,17 C10.9477153,17 10.5,17.4477153 10.5,18 L10.5,21 L5,21 L5,4 C5,2.8954305 5.8954305,2 7,2 L17,2 C18.1045695,2 19,2.8954305 19,4 L19,21 L13.5,21 Z M9,4 C8.44771525,4 8,4.44771525 8,5 L8,6 C8,6.55228475 8.44771525,7 9,7 L10,7 C10.5522847,7 11,6.55228475 11,6 L11,5 C11,4.44771525 10.5522847,4 10,4 L9,4 Z M14,4 C13.4477153,4 13,4.44771525 13,5 L13,6 C13,6.55228475 13.4477153,7 14,7 L15,7 C15.5522847,7 16,6.55228475 16,6 L16,5 C16,4.44771525 15.5522847,4 15,4 L14,4 Z M9,8 C8.44771525,8 8,8.44771525 8,9 L8,10 C8,10.5522847 8.44771525,11 9,11 L10,11 C10.5522847,11 11,10.5522847 11,10 L11,9 C11,8.44771525 10.5522847,8 10,8 L9,8 Z M9,12 C8.44771525,12 8,12.4477153 8,13 L8,14 C8,14.5522847 8.44771525,15 9,15 L10,15 C10.5522847,15 11,14.5522847 11,14 L11,13 C11,12.4477153 10.5522847,12 10,12 L9,12 Z M14,12 C13.4477153,12 13,12.4477153 13,13 L13,14 C13,14.5522847 13.4477153,15 14,15 L15,15 C15.5522847,15 16,14.5522847 16,14 L16,13 C16,12.4477153 15.5522847,12 15,12 L14,12 Z"
            fill="#000000"
          />
          <rect fill="#FFFFFF" x={13} y={8} width={3} height={3} rx={1} />
          <path
            d="M4,21 L20,21 C20.5522847,21 21,21.4477153 21,22 L21,22.4 C21,22.7313708 20.7313708,23 20.4,23 L3.6,23 C3.26862915,23 3,22.7313708 3,22.4 L3,22 C3,21.4477153 3.44771525,21 4,21 Z"
            fill="#000000"
            opacity="0.3"
          />
        </g>
      </svg>
      {/*end::Svg Icon*/}
    </span>
  );
};

export const Taxes = () => {
  return (
    <span className="svg-icon svg-icon-primary svg-icon-2x">
      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <rect x={0} y={0} width={24} height={24} />
          <path
            d="M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z"
            fill="#000000"
            opacity="0.3"
          />
          <path
            d="M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z"
            fill="#000000"
          />
          <rect
            fill="#000000"
            opacity="0.3"
            x={10}
            y={9}
            width={7}
            height={2}
            rx={1}
          />
          <rect
            fill="#000000"
            opacity="0.3"
            x={7}
            y={9}
            width={2}
            height={2}
            rx={1}
          />
          <rect
            fill="#000000"
            opacity="0.3"
            x={7}
            y={13}
            width={2}
            height={2}
            rx={1}
          />
          <rect
            fill="#000000"
            opacity="0.3"
            x={10}
            y={13}
            width={7}
            height={2}
            rx={1}
          />
          <rect
            fill="#000000"
            opacity="0.3"
            x={7}
            y={17}
            width={2}
            height={2}
            rx={1}
          />
          <rect
            fill="#000000"
            opacity="0.3"
            x={10}
            y={17}
            width={7}
            height={2}
            rx={1}
          />
        </g>
      </svg>
      {/*end::Svg Icon*/}
    </span>
  );
};

export const Groups = () => {
  return (
    <span className="svg-icon svg-icon-primary svg-icon-2x">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-shield-fill-check"
        viewBox="0 0 16 16"
        version="1.1"
      >
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <rect x={0} y={0} width={16} height={16} />
          <rect fill="#000000" x={4} y={4} width={7} height={7} rx="1.5" />
          <path
            d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zm2.146 5.146a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647z"
            fill="#000000"
            opacity="0.3"
          />
        </g>
      </svg>
    </span>
  );
};
export const Building = () => {
  return (
    <svg
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-buildings"
      viewBox="0 0 16 16"
    >
      <path d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022ZM6 8.694 1 10.36V15h5V8.694ZM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5V15Z" />
      <path d="M2 11h1v1H2v-1Zm2 0h1v1H4v-1Zm-2 2h1v1H2v-1Zm2 0h1v1H4v-1Zm4-4h1v1H8V9Zm2 0h1v1h-1V9Zm-2 2h1v1H8v-1Zm2 0h1v1h-1v-1Zm2-2h1v1h-1V9Zm0 2h1v1h-1v-1ZM8 7h1v1H8V7Zm2 0h1v1h-1V7Zm2 0h1v1h-1V7ZM8 5h1v1H8V5Zm2 0h1v1h-1V5Zm2 0h1v1h-1V5Zm0-2h1v1h-1V3Z" />
    </svg>
  );
};

export const GroupTesting = () => {
  return (
    <span className="svg-icon svg-icon-primary svg-icon-2x">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-google"
        viewBox="0 0 16 16"
        version="1.1"
      >
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
          <rect x={0} y={0} width={16} height={16} />
          <rect fill="#000000" x={4} y={4} width={7} height={7} rx="1.5" />
          <path
            d="M15.545 6.558a9.42 9.42 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.689 7.689 0 0 1 5.352 2.082l-2.284 2.284A4.347 4.347 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.792 4.792 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.702 3.702 0 0 0 1.599-2.431H8v-3.08h7.545z"
            fill="#000000"
            opacity="0.3"
          />
        </g>
      </svg>
    </span>
  );
};

export const Tax = () => {
  return (
    <svg
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-file-earmark-bar-graph"
      viewBox="0 0 16 16"
    >
      <path d="M10 13.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v6zm-2.5.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1zm-3 0a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-1z" />
      <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
    </svg>
  );
};

export const Coin = () => {
  return (
    <svg
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-coin"
      viewBox="0 0 16 16"
    >
      <path d="M5.5 9.511c.076.954.83 1.697 2.182 1.785V12h.6v-.709c1.4-.098 2.218-.846 2.218-1.932 0-.987-.626-1.496-1.745-1.76l-.473-.112V5.57c.6.068.982.396 1.074.85h1.052c-.076-.919-.864-1.638-2.126-1.716V4h-.6v.719c-1.195.117-2.01.836-2.01 1.853 0 .9.606 1.472 1.613 1.707l.397.098v2.034c-.615-.093-1.022-.43-1.114-.9H5.5zm2.177-2.166c-.59-.137-.91-.416-.91-.836 0-.47.345-.822.915-.925v1.76h-.005zm.692 1.193c.717.166 1.048.435 1.048.91 0 .542-.412.914-1.135.982V8.518l.087.02z" />
      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
      <path d="M8 13.5a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11zm0 .5A6 6 0 1 0 8 2a6 6 0 0 0 0 12z" />
    </svg>
  );
};

export const Inventory = () => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="24.000000pt"
      height="24.000000pt"
      viewBox="0 0 24.000000 24.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,24.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M73 190 l-43 -19 0 -71 0 -70 90 0 90 0 0 70 c0 66 -1 70 -27 83 -50
   26 -67 27 -110 7z m82 -17 c34 -16 35 -19 35 -70 0 -29 -4 -53 -10 -53 -5 0
   -10 9 -10 20 0 11 -4 20 -10 20 -5 0 -10 9 -10 20 0 16 -7 20 -30 20 -23 0
   -30 -4 -30 -20 0 -11 -4 -20 -10 -20 -5 0 -10 -9 -10 -20 0 -11 -4 -20 -10
   -20 -5 0 -10 24 -10 53 0 50 2 54 33 70 17 8 33 16 34 16 1 1 18 -7 38 -16z
   m-25 -73 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10
   -10z m-20 -40 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10
   -4 10 -10z m40 0 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0
   10 -4 10 -10z"
        />
      </g>
    </svg>
  );
};

export const Logs = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-journal-text"
      viewBox="0 0 16 16"
    >
      <path d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z" />
      <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z" />
      <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z" />
    </svg>
  );
};

export const Rating = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="16"
      width="16.75"
      viewBox="0 0 536 512"
    >
      <path d="M508.6 171.5L362.2 150.2 296.8 17.8C290.9 6 279.4 0 268 0c-11.4 0-22.8 5.9-28.7 17.8l-65.4 132.4-146.4 21.3c-26.3 3.8-36.8 36.1-17.7 54.6l105.9 103-25.1 145.5C87 495.3 103.6 512 122.2 512c4.9 0 10-1.2 14.9-3.8l131-68.7 130.9 68.7c4.9 2.6 9.9 3.7 14.8 3.7 18.6 0 35.2-16.6 31.7-37.4l-25-145.5 105.9-103c19-18.5 8.5-50.8-17.7-54.6zm-121.7 123.2l-18.1 17.6 4.3 24.9 19.5 113.5-102.1-53.6-22.4-11.7 0-317.2 51 103.3 11.2 22.6 25 3.6 114.2 16.6-82.7 80.4z" />
    </svg>
  );
};

// export const Reports = () => {
//   return (
//     <svg
//       fill="#000000"
//       version="1.1"
//       id="Capa_1"
//       xmlns="http://www.w3.org/2000/svg"
//       xmlns:xlink="http://www.w3.org/1999/xlink"
//       viewBox="0 0 60 60"
//       xml:space="preserve"
//     >
//       <g>
//         <g>
//           <path
//             d="M56.5,49L56.5,49V1c0-0.6-0.4-1-1-1h-45c-0.6,0-1,0.4-1,1v14h2V2h43v46h-9c-0.6,0-1,0.4-1,1v9h-33V43h-2v16
// 			c0,0.6,0.4,1,1,1h35c0.3,0,0.5-0.1,0.7-0.3l10-10c0.1-0.1,0.1-0.2,0.2-0.3v-0.1C56.5,49.2,56.5,49.1,56.5,49z M46.5,50h6.6
// 			l-3.3,3.3l-3.3,3.3L46.5,50L46.5,50z"
//           />
//           <path
//             d="M16.5,38h6h4v-2h-3V17c0-0.6-0.4-1-1-1h-6c-0.6,0-1,0.4-1,1v6h-5c-0.6,0-1,0.4-1,1v4h-5c-0.6,0-1,0.4-1,1v8
// 			c0,0.6,0.4,1,1,1h6H16.5z M17.5,18h4v18h-4V24V18z M11.5,25h4v11h-4v-7V25z M5.5,30h4v6h-4V30z"
//           />
//           <path
//             d="M50.5,24V7c0-0.6-0.4-1-1-1h-21c-0.6,0-1,0.4-1,1v17c0,0.6,0.4,1,1,1h21C50.1,25,50.5,24.6,50.5,24z M48.5,12h-12V8h12V12
// 			z M34.5,8v4h-5c0-1.6,0-4,0-4H34.5z M29.5,14h5v9h-5C29.5,23,29.5,18.3,29.5,14z M36.5,23v-9h12v9H36.5z"
//           />
//           <rect x="28.5" y="28" width="21" height="2" />
//           <rect x="28.5" y="33" width="21" height="2" />
//           <rect x="28.5" y="38" width="21" height="2" />
//           <rect x="14.5" y="6" width="6" height="2" />
//           <rect x="14.5" y="11" width="9" height="2" />
//           <rect x="14.5" y="43" width="7" height="2" />
//           <rect x="24.5" y="43" width="7" height="2" />
//           <rect x="34.5" y="43" width="7" height="2" />
//           <rect x="14.5" y="48" width="7" height="2" />
//           <rect x="24.5" y="48" width="7" height="2" />
//           <rect x="34.5" y="48" width="7" height="2" />
//           <rect x="14.5" y="53" width="7" height="2" />
//           <rect x="24.5" y="53" width="7" height="2" />
//           <rect x="34.5" y="53" width="7" height="2" />
//         </g>
//       </g>
//     </svg>
//   );
// };

export const OrderDelivered = () => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="512"
      height="512"
    >
      <path
        d="M0 0 C2.29931468 -0.00378841 4.59862706 -0.00929273 6.89793396 -0.01637268 C13.11061254 -0.03027477 19.32301256 -0.01919496 25.53567553 -0.00266147 C32.05278749 0.01124117 38.56988415 0.00472315 45.08700562 0.00120544 C56.02663736 -0.00149217 66.96615658 0.0118531 77.90576172 0.03515625 C89.1398527 0.05908368 100.37379827 0.06615426 111.60791016 0.05566406 C125.18072523 0.04301256 138.75342897 0.0455662 152.32624435 0.06132317 C157.49742581 0.06706812 162.66855861 0.06701205 167.83974075 0.06225777 C173.93182495 0.05747198 180.02370893 0.06765614 186.11575508 0.08921242 C188.34614321 0.09475813 190.57655067 0.09526605 192.80694008 0.09025955 C220.96367481 0.03500046 220.96367481 0.03500046 231.12646484 9.50170898 C238.52022266 17.06350675 241.27160509 25.71599544 241.22412109 36.11499023 C241.22089844 37.3621582 241.21767578 38.60932617 241.21435547 39.89428711 C241.20597656 41.18786133 241.19759766 42.48143555 241.18896484 43.81420898 C241.18445313 45.12711914 241.17994141 46.4400293 241.17529297 47.79272461 C241.16352433 51.02909909 241.14708244 54.26538076 241.12646484 57.50170898 C241.92889114 57.49282654 242.73131744 57.48394409 243.55805969 57.47479248 C251.16284594 57.39426058 258.76742208 57.33355025 266.37252522 57.2944603 C270.28133316 57.2736873 274.18978538 57.2455613 278.09838867 57.19995117 C281.87856166 57.15612156 285.65839501 57.13249476 289.43880272 57.12220001 C290.87275722 57.11487451 292.30669556 57.10057165 293.74050331 57.07878876 C304.71689508 56.91883862 313.88194996 58.08600511 322.87646484 64.81420898 C331.14714401 72.8512326 334.53574007 85.42254192 338.33349609 96.04467773 C339.48076614 99.19142915 340.6314527 102.33690889 341.78344727 105.48193359 C342.55327337 107.61867678 343.30400911 109.76239523 344.03540039 111.91259766 C349.34063828 127.41031572 354.65303874 135.72610075 369.27694702 143.44204712 C372.92694786 145.53327687 374.80600768 147.5403375 376.12646484 151.50170898 C376.23847515 154.34929097 376.29415941 157.17302156 376.3034668 160.02124023 C376.31003799 160.89158401 376.31660919 161.7619278 376.32337952 162.65864563 C376.34311381 165.54383431 376.35477881 168.4289708 376.36474609 171.31420898 C376.37085938 172.79543243 376.37085938 172.79543243 376.37709618 174.30657959 C376.39796293 179.53877554 376.41225895 184.77094526 376.42163086 190.00317383 C376.43266348 195.3886105 376.46702527 200.77363037 376.50680256 206.15892029 C376.5330516 210.314725 376.54133031 214.47043195 376.54491234 218.62631226 C376.5497612 220.61008501 376.56132624 222.59385391 376.57995033 224.57754517 C376.79245173 248.72305014 376.79245173 248.72305014 368.93896484 257.43920898 C361.30453973 264.18554573 353.54711911 265.07586923 343.65380859 264.89233398 C342.49015274 264.88667419 341.32649689 264.8810144 340.12757874 264.87518311 C336.43927518 264.85293164 332.75197093 264.80275405 329.06396484 264.75170898 C326.55160916 264.73162957 324.03923813 264.71338134 321.52685547 264.69702148 C315.39305545 264.65310363 309.25983157 264.58630384 303.12646484 264.50170898 C302.98547363 265.59878174 302.84448242 266.69585449 302.69921875 267.82617188 C301.21186034 277.371006 294.47327963 286.2733105 286.99755859 292.18530273 C275.39528485 300.27662755 262.32828996 304.40334508 248.18115234 302.00170898 C234.6909741 298.96555634 223.82092624 292.51960017 215.75146484 281.06420898 C212.82136881 276.33609947 209.12646484 270.1923462 209.12646484 264.50170898 C172.16646484 264.50170898 135.20646484 264.50170898 97.12646484 264.50170898 C96.46646484 267.47170898 95.80646484 270.44170898 95.12646484 273.50170898 C89.96418376 285.62260545 80.20383006 293.78647065 68.51708984 299.16186523 C55.52671832 304.29515721 42.16362245 303.4948407 29.23974609 298.35327148 C17.45290497 292.53551538 8.60703684 282.86603553 4.12646484 270.50170898 C3.77202557 268.5053413 3.43591981 266.50554249 3.12646484 264.50170898 C1.72122559 264.54884033 1.72122559 264.54884033 0.28759766 264.59692383 C-3.24632633 264.70024729 -6.77860698 264.77490333 -10.31347656 264.83129883 C-11.83229164 264.86115505 -13.35093919 264.90185733 -14.86914062 264.9543457 C-26.02129062 265.32976461 -34.73861856 264.2913245 -43.78857422 256.94775391 C-53.53325865 246.90436457 -52.44263644 232.87750531 -52.37524414 219.95068359 C-52.37903198 217.87663914 -52.38453584 215.80259722 -52.39161682 213.7285614 C-52.40552707 208.12117364 -52.39443307 202.51409424 -52.37790561 196.90672374 C-52.36400905 191.02575004 -52.37052036 185.14479341 -52.3740387 179.2638092 C-52.37673696 169.39082903 -52.36329742 159.51797071 -52.34008789 149.64501953 C-52.31347329 138.24498873 -52.31173489 126.84516149 -52.32347625 115.44511026 C-52.33427012 104.45829483 -52.32805479 93.47155274 -52.31392097 82.48474312 C-52.3081759 77.81792013 -52.3082322 73.15115107 -52.31298637 68.48432732 C-52.31777259 62.98568511 -52.30758635 57.48726469 -52.28603172 51.98866463 C-52.28048635 49.97555413 -52.27997779 47.96242221 -52.28498459 45.9493103 C-52.33937905 20.93437303 -52.33937905 20.93437303 -42.87353516 10.50170898 C-42.38240234 9.94483398 -41.89126953 9.38795898 -41.38525391 8.81420898 C-30.6702046 -1.82107569 -13.83894629 -0.06517291 0 0 Z M44.12646484 82.50170898 C43.18480469 83.4240332 43.18480469 83.4240332 42.22412109 84.36499023 C28.4048616 98.99899065 23.53737475 117.81611917 23.85302734 137.47436523 C24.62645486 157.57199418 34.56154051 174.58854771 48.93896484 188.25170898 C66.03464489 202.98029487 86.14022643 206.94156436 108.12646484 205.50170898 C127.10514426 203.02254844 144.13737186 191.64761737 155.83740234 176.84155273 C167.33226323 160.73022312 172.28704364 141.47638214 169.63037109 121.83374023 C165.70791002 101.86686211 155.41854437 84.27215126 138.62646484 72.56420898 C107.60142158 52.28424572 70.41753268 56.65549847 44.12646484 82.50170898 Z M241.12646484 79.50170898 C241.12646484 121.74170898 241.12646484 163.98170898 241.12646484 207.50170898 C244.09646484 207.00670898 244.09646484 207.00670898 247.12646484 206.50170898 C262.51701288 205.36141243 275.99314371 207.36354952 288.38818359 217.31811523 C294.64049595 223.2131526 299.03729814 230.02006475 301.70922852 238.17578125 C301.97571701 238.98596207 302.24220551 239.79614288 302.51676941 240.63087463 C302.7179689 241.24824997 302.9191684 241.86562531 303.12646484 242.50170898 C309.90734118 242.60299065 316.68802306 242.67312423 323.46948242 242.72143555 C325.77717376 242.74157162 328.08481395 242.76888254 330.39233398 242.8034668 C333.70618292 242.85189614 337.01935832 242.87465783 340.33349609 242.89233398 C341.36795364 242.91297913 342.40241119 242.93362427 343.46821594 242.95489502 C344.42898544 242.95519714 345.38975494 242.95549927 346.37963867 242.95581055 C347.22569168 242.96469299 348.07174469 242.97357544 348.94343567 242.98272705 C351.26533416 242.67342784 351.26533416 242.67342784 352.90185547 240.7598877 C354.27616081 238.22566974 354.49116913 236.77995054 354.46704102 233.91674805 C354.46681442 233.01611633 354.46658783 232.11548462 354.46635437 231.18756104 C354.44312859 229.74204865 354.44312859 229.74204865 354.41943359 228.26733398 C354.41518875 227.27417175 354.41094391 226.28100952 354.40657043 225.25775146 C354.38979118 222.08879371 354.35213985 218.92047421 354.31396484 215.75170898 C354.29891705 213.60197859 354.28522882 211.45223822 354.27294922 209.30249023 C354.2398902 204.03534575 354.18969818 198.76857297 354.12646484 193.50170898 C353.05686523 193.48188965 351.98726563 193.46207031 350.88525391 193.44165039 C346.91170972 193.36549918 342.93852719 193.27679657 338.96533203 193.18432617 C337.24665474 193.14607572 335.52789846 193.11121595 333.80908203 193.07983398 C331.33646445 193.03409771 328.86438871 192.97611815 326.39208984 192.91577148 C325.62527893 192.90422028 324.85846802 192.89266907 324.06842041 192.88076782 C320.30960968 192.77710077 317.27988757 192.67400113 314.12646484 190.50170898 C311.80522109 187.4840921 311.71457598 184.21191155 311.79833984 180.47045898 C312.31699252 177.35854295 313.91201259 175.65103029 316.12646484 173.50170898 C319.291081 171.91940091 322.71725851 172.26013085 326.19677734 172.18530273 C326.99300507 172.16452164 327.78923279 172.14374054 328.60958862 172.12232971 C331.1567917 172.0568675 333.7040991 171.99796483 336.25146484 171.93920898 C337.97673611 171.89602059 339.70199678 171.85240619 341.42724609 171.80834961 C345.66021169 171.70118954 349.89328237 171.59991275 354.12646484 171.50170898 C354.96065562 164.06743188 354.96065562 164.06743188 351.79052734 157.71264648 C350.78763672 157.10678711 349.78474609 156.50092773 348.75146484 155.87670898 C347.75373047 155.24506836 346.75599609 154.61342773 345.72802734 153.96264648 C341.81044505 151.76268285 339.74977294 151.37085552 335.22729492 151.34399414 C333.36945122 151.32860092 333.36945122 151.32860092 331.47407532 151.31289673 C330.80996454 151.30945881 330.14585377 151.30602089 329.46161842 151.30247879 C327.38013344 151.29068158 325.29885519 151.27122413 323.217453 151.24935913 C317.29876664 151.18779037 311.38009874 151.13381947 305.46118164 151.1003418 C301.84065716 151.07931294 298.22050543 151.04393889 294.60019493 150.9995842 C293.22443744 150.98548207 291.84861394 150.9767149 290.47278786 150.97352982 C276.37891126 150.93746673 276.37891126 150.93746673 271.12646484 147.50170898 C269.34401224 143.93249166 268.75416152 140.63635528 268.36450195 136.68920898 C268.2477562 135.54452148 268.13101044 134.39983398 268.01072693 133.22045898 C267.89294388 131.99327148 267.77516083 130.76608398 267.65380859 129.50170898 C267.52583389 128.23327148 267.39785919 126.96483398 267.26600647 125.65795898 C266.92750074 122.29352071 266.59509497 118.9286011 266.26605225 115.56323242 C265.8014034 110.82328096 265.32679972 106.08432354 264.85121155 101.34545898 C264.59881267 98.82493222 264.34938951 96.30410531 264.10325623 93.78295898 C263.98966263 92.63827148 263.87606903 91.49358398 263.7590332 90.31420898 C263.66069687 89.3100293 263.56236053 88.30584961 263.46104431 87.27124023 C263.14588174 84.66243525 262.64181353 82.0784524 262.12646484 79.50170898 C255.19646484 79.50170898 248.26646484 79.50170898 241.12646484 79.50170898 Z "
        fill="#000033"
        transform="translate(93.87353515625,104.498291015625)"
      />
      <path
        d="M0 0 C6.29694547 5.18277421 11.26178484 11.04801302 12.3125 19.37109375 C12.75895678 28.33457223 10.29808857 34.68566797 4.52734375 41.4921875 C-2.71650264 47.49927963 -8.49814401 50.18468346 -17.90234375 49.98828125 C-25.95406214 49.03452408 -31.47658057 44.8629525 -36.5625 38.77734375 C-41.56345797 31.44172105 -41.75144953 25.30224353 -41.03515625 16.6171875 C-39.73861805 9.86438437 -35.81132534 4.31445114 -30.23046875 0.328125 C-21.27636276 -5.01359488 -8.88039541 -5.85411541 0 0 Z "
        fill="#FCA323"
        transform="translate(365.03515625,335.3828125)"
      />
      <path
        d="M0 0 C6.33802257 2.91059405 12.16768312 7.9922159 15.00390625 14.43359375 C16.64505683 21.04980457 16.95265796 29.39169654 14.5625 35.875 C9.30626772 44.18323812 3.93810901 48.83313033 -5.375 51.9375 C-14.55118109 53.00627317 -21.18140582 50.96718136 -28.44921875 45.328125 C-33.92436517 40.32358865 -36.00043838 35.7378274 -36.72265625 28.41015625 C-37.03536716 20.38390947 -36.62885336 14.23420365 -31.375 7.9375 C-22.88931073 -1.00207498 -11.9523083 -3.81809849 0 0 Z "
        fill="#FCA323"
        transform="translate(154.375,333.0625)"
      />
      <path
        d="M0 0 C3.03483332 3.18287397 3.88036384 5.16254686 4.5 9.5 C3.55647555 16.10467112 -1.13448625 20.4362432 -5.71875 24.984375 C-6.25850464 25.52604309 -6.79825928 26.06771118 -7.35437012 26.62579346 C-8.48818607 27.76096183 -9.62449722 28.89364299 -10.76318359 30.02392578 C-12.50204756 31.7520349 -14.22992552 33.49061685 -15.95703125 35.23046875 C-17.06446312 36.33657968 -18.17251489 37.4420704 -19.28125 38.546875 C-19.79490112 39.06457458 -20.30855225 39.58227417 -20.83776855 40.11566162 C-24.69578501 43.92376656 -27.77745242 46.25737594 -33.25 46.5625 C-39.24702274 46.38669152 -42.01877134 43.14445194 -46 39 C-46.96726125 38.04923572 -47.93749991 37.10149425 -48.91015625 36.15625 C-57.88533928 27.37592861 -57.88533928 27.37592861 -58.3125 22.25 C-58.27266563 17.8761865 -56.80627251 15.3840345 -54 12 C-50.20942593 10.10471297 -46.10591733 10.2361084 -42 11 C-38.92023682 12.97420717 -36.46127344 15.30497434 -34 18 C-30.77731411 16.59004711 -28.70651132 14.91228948 -26.28515625 12.375 C-25.25551758 11.31539062 -25.25551758 11.31539062 -24.20507812 10.234375 C-22.77856261 8.74674168 -21.35407543 7.25716067 -19.93164062 5.765625 C-18.90006836 4.70601562 -18.90006836 4.70601562 -17.84765625 3.625 C-16.9196521 2.65433594 -16.9196521 2.65433594 -15.97290039 1.6640625 C-10.82629623 -2.67689208 -5.97275015 -2.52950426 0 0 Z "
        fill="#FFA522"
        transform="translate(218,215)"
      />
    </svg>
  );
};

export const TrackingOrder = () => {
  return (
    <svg
      height="197px"
      width="197px"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          style={{ fill: "#4C4C4C" }}
          d="M256,512H81.04c-31.072,0-56.352-25.28-56.352-56.352v-6.44c0-31.072,25.28-56.352,56.352-56.352 h93.384c4.447,0,8.05,3.603,8.05,8.05c0,4.447-3.603,8.05-8.05,8.05H81.04c-22.195,0-40.252,18.056-40.252,40.252v6.44 c0,22.195,18.056,40.252,40.252,40.252H256c4.447,0,8.05,3.603,8.05,8.05C264.05,508.397,260.447,512,256,512z"
        ></path>
        <path
          style={{ fill: "#4C4C4C" }}
          d="M437.4,408.956h-97.677c-4.447,0-8.05-3.603-8.05-8.05c0-4.447,3.603-8.05,8.05-8.05H437.4 c22.195,0,40.252-18.056,40.252-40.252v-15.027c0-22.195-18.056-40.252-40.252-40.252h-31.128c-4.447,0-8.05-3.603-8.05-8.05 s3.603-8.05,8.05-8.05H437.4c31.072,0,56.352,25.28,56.352,56.352v15.027C493.753,383.676,468.472,408.956,437.4,408.956z"
        ></path>
        <path
          style={{ fill: "#4C4C4C" }}
          d="M105.727,297.325H74.6c-31.072,0-56.352-25.28-56.352-56.352v-12.88c0-31.072,25.28-56.352,56.352-56.352 c4.447,0,8.05,3.603,8.05,8.05c0,4.447-3.603,8.05-8.05,8.05c-22.195,0-40.252,18.056-40.252,40.252v12.88 c0,22.195,18.056,40.252,40.252,40.252h31.128c4.447,0,8.05,3.603,8.05,8.05S110.174,297.325,105.727,297.325z"
        ></path>
      </g>
      <path
        style={{ fill: "#458FDE" }}
        d="M256,0C152.128,0,67.623,84.506,67.623,188.377c0,101.346,174.758,311.822,182.198,320.732 c1.53,1.832,3.792,2.891,6.179,2.891c2.387,0,4.65-1.058,6.179-2.891c7.44-8.91,182.198-219.386,182.198-320.732 C444.377,84.506,359.872,0,256,0z"
      ></path>
      <path
        style={{ fill: "#4F5AA8" }}
        d="M113.241,188.377c0-96.152,72.414-175.699,165.568-186.993C271.33,0.478,263.72,0,256,0 C152.128,0,67.623,84.506,67.623,188.377c0,101.346,174.758,311.822,182.198,320.732c1.53,1.832,3.792,2.891,6.179,2.891 c2.387,0,4.65-1.058,6.179-2.891c1.266-1.515,7.371-8.863,16.63-20.506C233.617,431.772,113.241,272.491,113.241,188.377z"
      ></path>
      <circle
        style={{ fill: "#AFF078" }}
        cx="256"
        cy="188.377"
        r="139.539"
      ></circle>
      <circle
        style={{ fill: "#5AC779" }}
        cx="256"
        cy="188.377"
        r="113.778"
      ></circle>
      <path
        style={{ fill: "#FFD652" }}
        d="M350.457,115.925H161.543c-4.447,0-8.05,3.603-8.05,8.05v137.392c0,4.447,3.603,8.05,8.05,8.05 h188.914c4.447,0,8.05-3.603,8.05-8.05V123.975C358.507,119.528,354.904,115.925,350.457,115.925z"
      ></path>
      <path
        style={{ fill: "#FB9D46" }}
        d="M161.543,115.925c-4.447,0-8.05,3.603-8.05,8.05v137.392c0,4.447,3.603,8.05,8.05,8.05h114.692 l-93.39-153.493H161.543z"
      ></path>
      <path
        style={{ fill: "#F7EDBC" }}
        d="M350.457,115.925h-42.398v153.493h42.398c4.447,0,8.05-3.603,8.05-8.05V123.975 C358.507,119.528,354.904,115.925,350.457,115.925z"
      ></path>
      <path
        style={{ fill: "#FF7452" }}
        d="M210.918,115.925v60.109c0,4.446,3.604,8.05,8.05,8.05h26.834c4.446,0,8.05-3.604,8.05-8.05v-60.109 H210.918z"
      ></path>
      <g>
        <path
          style={{ fill: "#4C4C4C" }}
          d="M281.761,222.189h-92.31c-4.447,0-8.05-3.603-8.05-8.05c0-4.447,3.603-8.05,8.05-8.05h92.31 c4.447,0,8.05,3.603,8.05,8.05C289.811,218.585,286.208,222.189,281.761,222.189z"
        ></path>
        <path
          style={{ fill: "#4C4C4C" }}
          d="M281.761,245.803h-92.31c-4.447,0-8.05-3.603-8.05-8.05c0-4.447,3.603-8.05,8.05-8.05h92.31 c4.447,0,8.05,3.603,8.05,8.05C289.811,242.2,286.208,245.803,281.761,245.803z"
        ></path>
      </g>
    </svg>
  );
};

export const NewOrderDelivered = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 512"
      width="20px"
      height="20px"
      fill="#3699FF"
    >
      <path d="M48 0C21.5 0 0 21.5 0 48V368c0 26.5 21.5 48 48 48H64c0 53 43 96 96 96s96-43 96-96H384c0 53 43 96 96 96s96-43 96-96h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V288 256 237.3c0-17-6.7-33.3-18.7-45.3L512 114.7c-12-12-28.3-18.7-45.3-18.7H416V48c0-26.5-21.5-48-48-48H48zM416 160h50.7L544 237.3V256H416V160zM112 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm368-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z" />
    </svg>
  );
};

export const Currency = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 576 512"
      width="20px"
      height="20px"
      fill="#3699FF"
    >
      <path
          style={{ fill: "#3699FF" }}
      d="M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zM272 192H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 304c0-8.8 7.2-16 16-16H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zM164 152v13.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V360c0 11-9 20-20 20s-20-9-20-20V345.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V152c0-11 9-20 20-20s20 9 20 20z"  />
    </svg>
  );
};
